export const PlayerIdMap = {
    "1": "Alex Abrines",
    "14": "Ike Anigbogu",
    "25": "Ron Baker",
    "26": "Wade Baldwin IV",
    "34": "Jerryd Bayless",
    "39": "Michael Beasley",
    "47": "Jabari Bird",
    "63": "Isaiah Briscoe",
    "67": "MarShon Brooks",
    "71": "Lorenzo Brown",
    "80": "Jose Calderon",
    "82": "Isaiah Canaan",
    "90": "Omri Casspi",
    "93": "Tyler Cavanaugh",
    "99": "Ian Clark",
    "113": "Dante Cunningham",
    "119": "Tyler Davis",
    "122": "Angel Delgado",
    "124": "Luol Deng",
    "141": "Trevon Duval",
    "142": "Vincent Edwards",
    "149": "Keenan Evans",
    "150": "Tyreke Evans",
    "155": "Raymond Felton",
    "179": "Marcin Gortat",
    "241": "Amir Johnson",
    "245": "Wesley Johnson",
    "263": "Kosta Koufos",
    "276": "Jon Leuer",
    "279": "Jeremy Lin",
    "280": "Shaun Livingston",
    "281": "Zach Lofton",
    "287": "Jordan Loyd",
    "382": "Billy Preston",
    "384": "Zhou Qi",
    "388": "Zach Randolph",
    "392": "Malachi Richardson",
    "423": "Jason Smith",
    "430": "DJ Stephens",
    "437": "Milos Teodosic",
    "438": "Jared Terrell",
    "448": "Gary Trent Jr.",
    "494": "Michael Smith",
    "495": "John Morton",
    "496": "Howard Wright",
    "497": "Michael Ansley",
    "498": "John Salley",
    "499": "Dan Schayes",
    "500": "Mark Eaton",
    "501": "Kevin Johnson",
    "502": "Danny Ainge",
    "503": "Kenny Smith",
    "504": "Randy Breuer",
    "505": "Herb Williams",
    "506": "Joe Wolf",
    "507": "Steve Johnson",
    "508": "Glen Rice",
    "509": "Greg Foster",
    "510": "Larry Nance",
    "511": "Duane Ferrell",
    "512": "Nick Anderson",
    "513": "Joe Dumars",
    "514": "Jay Humphries",
    "515": "Darrell Griffith",
    "516": "Dan Majerle",
    "517": "Tom Chambers",
    "518": "Alaa Abdelnaby",
    "519": "Adrian Caldwell",
    "520": "Vernon Maxwell",
    "521": "Doug West",
    "522": "Tony Campbell",
    "523": "Roy Tarpley",
    "524": "Anthony Cook",
    "525": "Todd Lichti",
    "526": "Tom Tolbert",
    "527": "Billy Thompson",
    "528": "Byron Irvin",
    "529": "Mark Price",
    "530": "Dominique Wilkins",
    "531": "Dennis Scott",
    "532": "Terry Catledge",
    "533": "Bill Laimbeer",
    "534": "William Bedford",
    "535": "Ricky Pierce",
    "536": "Blue Edwards",
    "537": "Walter Palmer",
    "538": "Mark West",
    "539": "Clifford Robinson",
    "540": "Hakeem Olajuwon",
    "541": "Richard Coffey",
    "542": "James Donaldson",
    "543": "Jerome Lane",
    "544": "Sarunas Marciulionis",
    "545": "Grant Long",
    "546": "Willie Burton",
    "547": "Mark Alarie",
    "548": "Winston Bennett",
    "549": "Doc Rivers",
    "550": "Tim McCormick",
    "551": "Scott Skiles",
    "552": "Dennis Rodman",
    "553": "Greg Anderson",
    "554": "Jeff Malone",
    "555": "Cedric Ceballos",
    "556": "Tim Perry",
    "557": "Buck Williams",
    "558": "Dave Jamerson",
    "559": "Scott Brooks",
    "560": "Rolando Blackman",
    "561": "Avery Johnson",
    "562": "Rod Higgins",
    "563": "Jon Sundvold",
    "564": "A.J. English",
    "565": "John Battle",
    "566": "Sam Vincent",
    "567": "Isiah Thomas",
    "568": "Brad Lohaus",
    "569": "Mike Brown",
    "570": "Kenny Battle",
    "571": "Danny Young",
    "572": "Larry Smith",
    "573": "Pooh Richardson",
    "574": "Derek Harper",
    "575": "Michael Adams",
    "576": "Tim Hardaway",
    "577": "Bimbo Coles",
    "578": "Darrell Walker",
    "579": "Kevin Willis",
    "580": "Otis Smith",
    "581": "James Edwards",
    "582": "Frank Brickowski",
    "583": "Karl Malone",
    "584": "Ian Lockhart",
    "585": "Kevin Duckworth",
    "586": "Otis Thorpe",
    "587": "Gerald Glass",
    "588": "Alex English",
    "589": "T.R. Dunn",
    "590": "Alton Lister",
    "591": "Sherman Douglas",
    "592": "Charles Jones",
    "593": "Moses Malone",
    "594": "Mark Acres",
    "595": "Lance Blanks",
    "596": "Jeff Grayer",
    "597": "Chris Munk",
    "598": "Jeff Hornacek",
    "599": "Jerome Kersey",
    "600": "Dave Feitl",
    "601": "Tod Murphy",
    "602": "Lafayette Lever",
    "603": "Corey Gaines",
    "604": "Mitch Richmond",
    "605": "Kevin Edwards",
    "606": "Haywoode Workman",
    "607": "Tom Hammonds",
    "608": "Rumeal Robinson",
    "609": "Greg Kite",
    "610": "Vinnie Johnson",
    "611": "Jack Sikma",
    "612": "Delaney Rudd",
    "613": "Ed Nealy",
    "614": "Wayne Cooper",
    "615": "Sleepy Floyd",
    "616": "Felton Spencer",
    "617": "Tyrone Corbin",
    "618": "Marcus Liberty",
    "619": "Walter Davis",
    "620": "Tyrone Hill",
    "621": "Alec Kessler",
    "622": "Terry Davis",
    "623": "Larry Robinson",
    "624": "Sidney Moncrief",
    "625": "Jeff Turner",
    "626": "Scott Hastings",
    "627": "Alvin Robertson",
    "628": "Steve Henson",
    "629": "Andy Toolson",
    "630": "Thurl Bailey",
    "631": "Kurt Rambis",
    "632": "Clyde Drexler",
    "633": "David Wood",
    "634": "Sam Mitchell",
    "635": "Rodney McCray",
    "636": "Blair Rasmussen",
    "637": "Kevin Pritchard",
    "638": "Milt Wagner",
    "639": "Bernard King",
    "640": "Roy Hinson",
    "641": "Matt Bullard",
    "642": "Alan Ogg",
    "643": "Kevin Lynch",
    "644": "Larry Krystkowiak",
    "645": "Pete Chilcutt",
    "646": "Randy Brown",
    "647": "Elliot Perry",
    "648": "Jimmy Oliver",
    "649": "Terrell Brandon",
    "650": "Greg Sutton",
    "651": "Tom Copa",
    "652": "Donald Hodge",
    "653": "Joao Vianna",
    "654": "Mike Iuzzolino",
    "655": "Greg Anthony",
    "656": "Albert King",
    "657": "Tellis Frank",
    "658": "David Benoit",
    "659": "Demetrius Calip",
    "660": "Dikembe Mutombo",
    "661": "Mark Macon",
    "662": "Chris Gatling",
    "663": "Victor Alexander",
    "664": "Mark Randall",
    "665": "Mitchell Wiggins",
    "666": "Tharon Mayes",
    "667": "Charles Thomas",
    "668": "Robert Pack",
    "669": "John Bagley",
    "670": "Rick Fox",
    "671": "Larry Johnson",
    "672": "Alexander Volkov",
    "673": "Stacey Augmon",
    "674": "Carl Thomas",
    "675": "Steven Smith",
    "676": "Stanley Roberts",
    "677": "Doug Lee",
    "678": "Rafael Addison",
    "679": "Sean Green",
    "680": "Corey Crowder",
    "681": "Eric Murdock",
    "682": "Kevin Brooks",
    "683": "Carlton McKinney",
    "684": "Billy Owens",
    "685": "Doug Smith",
    "686": "Marty Conlon",
    "687": "Rich King",
    "688": "Brad Sellers",
    "689": "Rodney Monroe",
    "690": "Lanard Copeland",
    "691": "LeRon Ellis",
    "692": "Larry Stewart",
    "693": "John Turner",
    "694": "Charles Shackleford",
    "695": "Keith Owens",
    "696": "Paul Graham",
    "697": "Kenny Anderson",
    "698": "Carl Herrera",
    "699": "Myron Brown",
    "700": "Dale Davis",
    "701": "Labradford Smith",
    "702": "Bison Dele",
    "703": "Chuck Nevitt",
    "704": "Patrick Eddie",
    "705": "David Rivers",
    "706": "Luc Longley",
    "707": "Bob McCann",
    "708": "Donald Royal",
    "709": "Anthony Bowie",
    "710": "Chris Corchiani",
    "711": "Stephen Thompson",
    "712": "Jeff Ruland",
    "713": "Ronnie Grandison",
    "714": "Lamont Strothers",
    "715": "Tracy Moore",
    "716": "Jaren Jackson",
    "717": "Ennis Whatley",
    "718": "Brian Howard",
    "719": "Steve Burtt",
    "720": "Cedric Hunter",
    "721": "Stephen Bardo",
    "722": "Cliff T. Robinson",
    "723": "Derek Strong",
    "724": "Bobby Phills",
    "725": "Anthony Avent",
    "726": "Lee Mayberry",
    "727": "Todd Day",
    "728": "Tony Bennett",
    "729": "Brent Price",
    "730": "Don MacLean",
    "731": "Tom Gugliotta",
    "732": "Walt Williams",
    "733": "Lloyd Daniels",
    "734": "Vinny Del Negro",
    "735": "Shaquille O'Neal",
    "736": "Adam Keefe",
    "737": "Clar. Weatherspoon",
    "738": "Robert Horry",
    "739": "Chris Smith",
    "740": "Christian Laettner",
    "741": "Gundars Vetra",
    "742": "Corey Williams",
    "743": "Elmore Spencer",
    "744": "Anthony Peeler",
    "745": "Duane Cooper",
    "746": "John Crotty",
    "747": "Stephen Howard",
    "748": "Byron Houston",
    "749": "Keith Jennings",
    "750": "Latrell Sprewell",
    "751": "Bryant Stith",
    "752": "LaPhonso Ellis",
    "753": "Matt Othick",
    "754": "Sam Mack",
    "755": "Anthony Pullard",
    "756": "Malik Sealy",
    "757": "Hubert Davis",
    "758": "Sean Rooks",
    "759": "Walter Bond",
    "760": "Harold Miner",
    "761": "Oliver Miller",
    "762": "Lorenzo Williams",
    "763": "Dave Johnson",
    "764": "Reggie Smith",
    "765": "Tracy Murray",
    "766": "Robert Werdann",
    "767": "Alex Stivrins",
    "768": "Frank Johnson",
    "769": "Randy Woods",
    "770": "Litterial Green",
    "771": "Alonzo Mourning",
    "772": "Alex Blackwell",
    "773": "Isaiah Morris",
    "774": "Doug Overton",
    "775": "Eric Anderson",
    "776": "Tim Kempton",
    "777": "Stan Kimbrough",
    "778": "Jay Guidinger",
    "779": "Gary Plummer",
    "780": "Matt Geiger",
    "781": "Marcus Webb",
    "782": "Jojo English",
    "783": "Marlon Maxey",
    "784": "Jon Barry",
    "785": "Richard Dumas",
    "786": "Radisav Curcic",
    "787": "Andre Spencer",
    "788": "Dexter Cambridge",
    "789": "Joe Courtney",
    "790": "Duane Washington",
    "791": "Melvin Newbern",
    "792": "Ricky Blanton",
    "793": "Jim Jackson",
    "794": "Barry Stevens",
    "795": "Doug Christie",
    "796": "Pat Durham",
    "797": "Thomas Jordan",
    "798": "Gary Alexander",
    "799": "Anfernee Hardaway",
    "800": "Keith Tower",
    "801": "Chris Whitney",
    "802": "Josh Grant",
    "803": "Bobby Hurley",
    "804": "Mike Peplowski",
    "805": "Darnell Mee",
    "806": "Rodney Rogers",
    "807": "Acie Earl",
    "808": "Dino Radja",
    "809": "Chris Mills",
    "810": "Vin Baker",
    "811": "Antonio Harvey",
    "812": "Nick Van Exel",
    "813": "Terry Dehere",
    "814": "James Robinson",
    "815": "Corie Blount",
    "816": "Toni Kukoc",
    "817": "Michael Curry",
    "818": "Shawn Bradley",
    "819": "Warren Kidd",
    "820": "Calbert Cheaney",
    "821": "Mitchell Butler",
    "822": "Tito Horford",
    "823": "Bryon Russell",
    "824": "Luther Wright",
    "825": "Darren Morningstar",
    "826": "Jamal Mashburn",
    "827": "Lucious Harris",
    "828": "Popeye Jones",
    "829": "Eric Riley",
    "830": "Sam Cassell",
    "831": "P.J. Brown",
    "832": "Rex Walters",
    "833": "Antonio Davis",
    "834": "Allan Houston",
    "835": "Lindsey Hunter",
    "836": "Brian Davis",
    "837": "Isaiah Rider",
    "838": "Matt Wenstrom",
    "839": "Scott Haskin",
    "840": "Gerald Madkins",
    "841": "Greg Graham",
    "842": "Ervin Johnson",
    "843": "George Lynch",
    "844": "Bob Martin",
    "845": "Ricky Grace",
    "846": "Sedric Toney",
    "847": "Chris Webber",
    "848": "Gheorghe Muresan",
    "849": "Richard Petruska",
    "850": "Kevin Thompson",
    "851": "Adonis Jordan",
    "852": "Scott Burrell",
    "853": "Dell Demps",
    "854": "Evers Burns",
    "855": "Aaron Williams",
    "856": "Stanley Jackson",
    "857": "David Wesley",
    "858": "Chris King",
    "859": "Doug Edwards",
    "860": "Harold Ellis",
    "861": "Malcolm Mackey",
    "862": "Ben Coleman",
    "863": "Roy Marble",
    "864": "Reggie Jordan",
    "865": "Chad Gallagher",
    "866": "Bo Outlaw",
    "867": "Bill Edwards",
    "868": "Andrew Gaze",
    "869": "Alphonso Ford",
    "870": "Andres Guibert",
    "871": "Skeeter Henry",
    "872": "Chris Jent",
    "873": "Geert Hammink",
    "874": "Jalen Rose",
    "875": "Reggie Slater",
    "876": "Askia Jones",
    "877": "Donyell Marshall",
    "878": "Howard Eisley",
    "879": "Grant Hill",
    "880": "Anthony Miller",
    "881": "Eddie Jones",
    "882": "Dickey Simpkins",
    "883": "Eric Piatkowski",
    "884": "Lamond Murray",
    "885": "Matt Fish",
    "886": "Aaron McKie",
    "887": "Eric Montross",
    "888": "Fred Vinson",
    "889": "Tom Hovasse",
    "890": "Jamie Watson",
    "891": "Khalid Reeves",
    "892": "Brian Grant",
    "893": "Henry Turner",
    "894": "Michael Smith",
    "895": "Antonio Lang",
    "896": "Wesley Person",
    "897": "B.J. Tyler",
    "898": "Derrick Alston",
    "899": "Sharone Wright",
    "900": "Eric Mobley",
    "901": "Darrin Hancock",
    "902": "Bill Curley",
    "903": "Anthony Tucker",
    "904": "Tim Breaux",
    "905": "Zan Tabak",
    "906": "Brooks Thompson",
    "907": "Glenn Robinson",
    "908": "Jason Kidd",
    "909": "Tony Dumas",
    "910": "Monty Williams",
    "911": "Carlos Rogers",
    "912": "Sergei Bazarevich",
    "913": "Julius Nwosu",
    "914": "Trevor Ruffin",
    "915": "Yinka Dare",
    "916": "Greg Minor",
    "917": "Clifford Rozier",
    "918": "Charlie Ward",
    "919": "Dontonio Wingfield",
    "920": "Aaron Swinson",
    "921": "Jim McIlvaine",
    "922": "Juwan Howard",
    "923": "James Blackwell",
    "924": "Ivano Newbill",
    "925": "Dwayne Morton",
    "926": "Chris Childs",
    "927": "Ryan Lorthridge",
    "928": "Elmer Bennett",
    "929": "Darrick Martin",
    "930": "Jerome Harmon",
    "931": "Mark Strickland",
    "932": "Eldridge Recasner",
    "933": "Darrell Armstrong",
    "934": "Derrick Phelps",
    "935": "Cherokee Parks",
    "936": "Loren Meyer",
    "937": "Charles Claxton",
    "938": "Eric Williams",
    "939": "Junior Burrough",
    "940": "Brent Barry",
    "941": "Chris Carr",
    "942": "Michael Finley",
    "943": "Greg Ostertag",
    "944": "Eric Snow",
    "945": "Sherell Ford",
    "946": "Jerry Stackhouse",
    "947": "Jeff Webster",
    "948": "Rasheed Wallace",
    "949": "Arvydas Sabonis",
    "950": "Gary Trent",
    "951": "Randolph Childress",
    "952": "Bryant Reeves",
    "953": "Lawrence Moten",
    "954": "Jason Caffey",
    "955": "George Zidek",
    "956": "Alvin Heggs",
    "957": "Joe Smith",
    "958": "Alan Henderson",
    "959": "Travis Best",
    "960": "Damon Stoudamire",
    "961": "Jimmy King",
    "962": "Ed O'Bannon",
    "963": "Lou Roe",
    "964": "Theo Ratliff",
    "965": "Antonio McDyess",
    "966": "Bob Sura",
    "967": "Donny Marshall",
    "968": "John Amaechi",
    "969": "Tyus Edney",
    "970": "Jerome Allen",
    "971": "Kevin Garnett",
    "972": "Mark Davis",
    "973": "Marques Bragg",
    "974": "Shawn Respert",
    "975": "Fred Hoiberg",
    "976": "Frankie King",
    "977": "Don Reid",
    "978": "Kurt Thomas",
    "979": "Sasha Danilovic",
    "980": "Terrence Rencher",
    "981": "Cory Alexander",
    "982": "Howard Nathan",
    "983": "Todd Mundt",
    "984": "David Vaughn",
    "985": "Log Vander Velden",
    "986": "Ashraf Amaya",
    "987": "Stefano Rusconi",
    "988": "Larry Sykes",
    "989": "Vincenzo Esposito",
    "990": "Corliss Williamson",
    "991": "Rastko Cvetkovic",
    "992": "Corey Beck",
    "993": "Voshon Lenard",
    "994": "Anthony Goldwire",
    "995": "Andrew DeClercq",
    "996": "Richard Manning",
    "997": "Clint McDaniel",
    "998": "Martin Lewis",
    "999": "Dwayne Whitfield",
    "1000": "Mario Bennett",
    "1001": "Melvin Booker",
    "1002": "Darryl Johnson",
    "1003": "John Coker",
    "1004": "Donnie Boyce",
    "1005": "Thomas Hamilton",
    "1006": "Robert Churchwell",
    "1007": "Cuonzo Martin",
    "1008": "Cedric Lewis",
    "1009": "Antoine Walker",
    "1010": "Brett Szabo",
    "1011": "Brent Scott",
    "1012": "Erick Dampier",
    "1013": "Jerome Williams",
    "1014": "John Wallace",
    "1015": "Walter McCarty",
    "1016": "Marcus Camby",
    "1017": "Donald Whiteside",
    "1018": "Shareef Abdur-Rahim",
    "1019": "Roy Rogers",
    "1020": "Ben Wallace",
    "1021": "Reggie Geary",
    "1022": "Vitaly Potapenko",
    "1023": "Ed O'Bannon",
    "1024": "Kerry Kittles",
    "1025": "Erick Strickland",
    "1026": "Darvin Ham",
    "1027": "Stephon Marbury",
    "1028": "Shane Heal",
    "1029": "Dean Garrett",
    "1030": "Priest Lauderdale",
    "1031": "Ike Austin",
    "1032": "Loy Vaught",
    "1033": "Lorenzen Wright",
    "1034": "Todd Fuller",
    "1035": "Ray Owes",
    "1036": "Ray Allen",
    "1037": "Allen Iverson",
    "1038": "Mark Bradtke",
    "1039": "Steve Nash",
    "1040": "Ben Davis",
    "1041": "Derek Fisher",
    "1042": "Travis Knight",
    "1043": "Kobe Bryant",
    "1044": "Matt Maloney",
    "1045": "Othella Harrington",
    "1046": "Randy Livingston",
    "1047": "Emanual Davis",
    "1048": "Shandon Anderson",
    "1049": "Malik Rose",
    "1050": "Tony Delk",
    "1051": "Jeff McInnis",
    "1052": "Dontae' Jones",
    "1053": "Nate Driggers",
    "1054": "Samaki Walker",
    "1055": "Amal McCaskill",
    "1056": "James Scott",
    "1057": "Mark Hendrickson",
    "1058": "Aleksandar Djordjevic",
    "1059": "Jermaine O'Neal",
    "1060": "Chris Robinson",
    "1061": "Kevin Salvadori",
    "1062": "Evric Gray",
    "1063": "Moochie Norris",
    "1064": "Devin Gray",
    "1065": "Martin Muursepp",
    "1066": "Gaylon Nickerson",
    "1067": "Marcus Brown",
    "1068": "Robert Werdann",
    "1069": "Ruben Nembhard",
    "1070": "Jamie Feick",
    "1071": "Jason Sasser",
    "1072": "Tony Farmer",
    "1073": "Shawnelle Scott",
    "1074": "Brian Evans",
    "1075": "Steve Hamer",
    "1076": "Dexter Boney",
    "1077": "Michael Hawkins",
    "1078": "Joe Stephens",
    "1079": "Horacio Llamas",
    "1080": "Jimmy Carruth",
    "1081": "Bruce Bowen",
    "1082": "Stevin Smith",
    "1083": "Matt Steigenga",
    "1084": "Kevin Ollie",
    "1085": "Bubba Wells",
    "1086": "Antonio Daniels",
    "1087": "Tracy McGrady",
    "1088": "Chris Garner",
    "1089": "Tim Duncan",
    "1090": "Tony Battie",
    "1091": "Bobby Jackson",
    "1092": "Danny Fortson",
    "1093": "Eric Washington",
    "1094": "Etdrick Bohannon",
    "1095": "Mark Pope",
    "1096": "Ron Mercer",
    "1097": "Chauncey Billups",
    "1098": "John Thomas",
    "1099": "Kelvin Cato",
    "1100": "Alvin Williams",
    "1101": "Maurice Taylor",
    "1102": "Keith Closs",
    "1103": "Adonal Foyle",
    "1104": "DeJuan Wheat",
    "1105": "Ed Gray",
    "1106": "Chris Crawford",
    "1107": "Zydrunas Ilgauskas",
    "1108": "Derek Anderson",
    "1109": "Brevin Knight",
    "1110": "Cedric Henderson",
    "1111": "Rodrick Rhodes",
    "1112": "Jacque Vaughn",
    "1113": "Troy Hudson",
    "1114": "Jerald Honeycutt",
    "1115": "Jeff Nordgaard",
    "1116": "Tim Thomas",
    "1117": "God Shammgod",
    "1118": "Scot Pollard",
    "1119": "Keith Van Horn",
    "1120": "Michael Stewart",
    "1121": "Anthony Johnson",
    "1122": "Derek Grimm",
    "1123": "Lawrence Funderburke",
    "1124": "Chris Anstey",
    "1125": "Rick Brunson",
    "1126": "Travis Williams",
    "1127": "Tariq Abdul-Wahad",
    "1128": "Charles Smith",
    "1129": "Keith Booth",
    "1130": "Ed Stokes",
    "1131": "Charles O'Bannon",
    "1132": "Austin Croshere",
    "1133": "Rusty LaRue",
    "1134": "Kiwane Garris",
    "1135": "Marko Milic",
    "1136": "Johnny Taylor",
    "1137": "James Cotton",
    "1138": "James Collins",
    "1139": "Anthony Parker",
    "1140": "Jason Lawson",
    "1141": "Kebu Stewart",
    "1142": "Kelly McCarty",
    "1143": "Drew Barry",
    "1144": "Michael McDonald",
    "1145": "Brandon Williams",
    "1146": "William Cunningham",
    "1147": "Shea Seals",
    "1148": "Reggie Hanson",
    "1149": "Rashard Lewis",
    "1150": "Jelani McCoy",
    "1151": "Vladimir Stepania",
    "1152": "Larry Hughes",
    "1153": "Casey Shaw",
    "1154": "Nazr Mohammed",
    "1155": "Ricky Davis",
    "1156": "Brad Miller",
    "1157": "Mikki Moore",
    "1158": "Michael Doleac",
    "1159": "Matt Harpring",
    "1160": "Miles Simon",
    "1161": "Jason Williams",
    "1162": "Peja Stojakovic",
    "1163": "Jerome James",
    "1164": "Peter Aluma",
    "1165": "Gerard King",
    "1166": "Mark Baker",
    "1167": "Sean Marks",
    "1168": "Paul Pierce",
    "1169": "Marlon Garnett",
    "1170": "Jahidi White",
    "1171": "Randell Jackson",
    "1172": "Al Harrington",
    "1173": "Shammond Williams",
    "1174": "Jeff Sheppard",
    "1175": "Roshown McLeod",
    "1176": "Pat Garrity",
    "1177": "Gerald Brown",
    "1178": "Toby Bailey",
    "1179": "Michael Olowokandi",
    "1180": "Tyrone Nesby",
    "1181": "Michael Dickerson",
    "1182": "Bryce Drew",
    "1183": "John Coker",
    "1184": "Cuttino Mobley",
    "1185": "Ruben Patterson",
    "1186": "Sam Jacobson",
    "1187": "Tyronn Lue",
    "1188": "Kornel David",
    "1189": "Cory Carr",
    "1190": "Corey Benjamin",
    "1191": "Paul Grant",
    "1192": "Andrae Patterson",
    "1193": "Raef LaFrentz",
    "1194": "Keon Clark",
    "1195": "Tyson Wheeler",
    "1196": "Robert Traylor",
    "1197": "Earl Boykins",
    "1198": "Antawn Jamison",
    "1199": "Mike Bibby",
    "1200": "Felipe Lopez",
    "1201": "J.R. Henderson",
    "1202": "Bonzi Wells",
    "1203": "Damon Jones",
    "1204": "Charles R. Jones",
    "1205": "Ryan Stack",
    "1206": "Brian Skinner",
    "1207": "Jonathan Kerner",
    "1208": "Korleone Young",
    "1209": "Trevor Winter",
    "1210": "Bruno Sundov",
    "1211": "Mirsad Turkcan",
    "1212": "Alvin Sims",
    "1213": "Rasho Nesterovic",
    "1214": "Todd MacCulloch",
    "1215": "Jumaine Jones",
    "1216": "Lamar Odom",
    "1217": "Obinna Ekezie",
    "1218": "Milt Palacio",
    "1219": "Devean George",
    "1220": "Quincy Lewis",
    "1221": "Scott Padgett",
    "1222": "Andre Miller",
    "1223": "Trajan Langdon",
    "1224": "Anthony Carter",
    "1225": "Rodney Buford",
    "1226": "Shawn Marion",
    "1227": "James Posey",
    "1228": "Ryan Bowen",
    "1229": "Adrian Griffin",
    "1230": "Wayne Turner",
    "1231": "Aleksandar Radojevic",
    "1232": "Steve Francis",
    "1233": "Kenny Thomas",
    "1234": "Vonteego Cummings",
    "1235": "Corey Maggette",
    "1236": "Chucky Atkins",
    "1237": "Baron Davis",
    "1238": "Jason Miskiri",
    "1239": "Eddie Robinson",
    "1240": "Derek Hood",
    "1241": "Jeff Foster",
    "1242": "Jason Terry",
    "1243": "Cal Bowdler",
    "1244": "Dion Glover",
    "1245": "Richard Hamilton",
    "1246": "Laron Profit",
    "1247": "Elton Brand",
    "1248": "Michael Ruffin",
    "1249": "Metta World Peace",
    "1250": "Dedric Willoughby",
    "1251": "Wally Szczerbiak",
    "1252": "William Avery",
    "1253": "Rick Hughes",
    "1254": "Leon Smith",
    "1255": "Lazaro Borrell",
    "1256": "Jermaine Jackson",
    "1257": "Chris Herren",
    "1258": "John Celestand",
    "1259": "Lari Ketner",
    "1260": "Tim Young",
    "1261": "DeMarco Johnson",
    "1262": "A.J. Bramlett",
    "1263": "Harold Jamison",
    "1264": "Jonathan Bender",
    "1265": "Jamel Thomas",
    "1266": "Evan Eschmeyer",
    "1267": "Greg Buckner",
    "1268": "Tim James",
    "1269": "Rafer Alston",
    "1270": "Ira Bowman",
    "1271": "Derrick Dial",
    "1272": "Calvin Booth",
    "1273": "Maceo Baston",
    "1274": "Jamaal Magloire",
    "1275": "Hanno Mottola",
    "1276": "DerMarr Johnson",
    "1277": "Pepe Sanchez",
    "1278": "Lavor Postell",
    "1279": "Chris Mihm",
    "1280": "Stephen Jackson",
    "1281": "Kenyon Martin",
    "1282": "Soumaila Samake",
    "1283": "Desmond Mason",
    "1284": "Ruben Wolkowyski",
    "1285": "Stromile Swift",
    "1286": "Joel Przybilla",
    "1287": "Michael Redd",
    "1288": "Eduardo Najera",
    "1289": "Courtney Alexander",
    "1290": "Hedo Turkoglu",
    "1291": "Khalid El-Amin",
    "1292": "Marcus Fizer",
    "1293": "A.J. Guyton",
    "1294": "Dragan Tarlac",
    "1295": "Darius Miles",
    "1296": "Keyon Dooling",
    "1297": "Quentin Richardson",
    "1298": "DeShawn Stevenson",
    "1299": "Mike Miller",
    "1300": "Mark Madsen",
    "1301": "Erick Barkley",
    "1302": "Mateen Cleaves",
    "1303": "Morris Peterson",
    "1304": "Jason Collier",
    "1305": "Daniel Santiago",
    "1306": "Paul McPherson",
    "1307": "Ruben Garces",
    "1308": "Jake Tsakalidis",
    "1309": "Marc Jackson",
    "1310": "Chris Porter",
    "1311": "Jamal Robinson",
    "1312": "Eddie House",
    "1313": "Jerome Moiso",
    "1314": "Mark Blount",
    "1315": "Dan Langhi",
    "1316": "Garth Joseph",
    "1317": "Jake Voskuhl",
    "1318": "Mike Penberthy",
    "1319": "Lee Nailon",
    "1320": "Zendon Hamilton",
    "1321": "Terrance Roberson",
    "1322": "Dalibor Bagaric",
    "1323": "Ira Newble",
    "1324": "Donnell Harvey",
    "1325": "Brian Cardinal",
    "1326": "Slava Medvedenko",
    "1327": "Olumide Oyedeji",
    "1328": "Andy Panko",
    "1329": "Jabari Smith",
    "1330": "Mamadou N'diaye",
    "1331": "Sean Colson",
    "1332": "Art Long",
    "1333": "Mike Smith",
    "1334": "David Vanterpool",
    "1335": "Steve Goodrich",
    "1336": "Eddie Gill",
    "1337": "Wang Zhi-zhi",
    "1338": "Dan McClintock",
    "1339": "Raja Bell",
    "1340": "Jason Hart",
    "1341": "Vladimir Radmanovic",
    "1342": "Earl Watson",
    "1343": "Gerald Wallace",
    "1344": "Jamaal Tinsley",
    "1345": "Primoz Brezec",
    "1346": "Richard Jefferson",
    "1347": "Brandon Armstrong",
    "1348": "Jason Collins",
    "1349": "Carlos Arroyo",
    "1350": "Michael Bradley",
    "1351": "Steven Hunter",
    "1352": "Andrei Kirilenko",
    "1353": "Alton Ford",
    "1354": "Charlie Bell",
    "1355": "Speedy Claxton",
    "1356": "Damone Brown",
    "1357": "Loren Woods",
    "1358": "Eddie Griffin",
    "1359": "Oscar Torres",
    "1360": "Tierre Brown",
    "1361": "Terence Morris",
    "1362": "Zeljko Rebraca",
    "1363": "Rodney White",
    "1365": "Joseph Forte",
    "1366": "Kedrick Brown",
    "1367": "DeSagana Diop",
    "1368": "Kwame Brown",
    "1369": "Bobby Simmons",
    "1370": "Etan Thomas",
    "1371": "Ruben Boumtje-Boumtje",
    "1372": "Jason Richardson",
    "1373": "Troy Murphy",
    "1374": "Gilbert Arenas",
    "1375": "Trenton Hassell",
    "1376": "Eddy Curry",
    "1377": "Tang Hamilton",
    "1378": "Shane Battier",
    "1379": "Will Solomon",
    "1380": "Antonis Fotsis",
    "1381": "Alvin Jones",
    "1382": "Jeff Trepagnier",
    "1383": "Joe Crispin",
    "1384": "Ernest Brown",
    "1385": "Jarron Collins",
    "1386": "Jamison Brewer",
    "1387": "Malik Allen",
    "1388": "Predrag Drobnjak",
    "1389": "Chris Andersen",
    "1390": "Kenny Satterfield",
    "1391": "Brendan Haywood",
    "1392": "Kirk Haston",
    "1393": "Samuel Dalembert",
    "1394": "Mike James",
    "1395": "Maurice Evans",
    "1396": "Jeryl Sasser",
    "1397": "Dean Oliver",
    "1398": "Norman Richardson",
    "1399": "Brian Scalabrine",
    "1400": "Ratko Varda",
    "1401": "Tremaine Fowlkes",
    "1402": "Mengke Bateer",
    "1403": "Ike Fontaine",
    "1404": "Ansu Sesay",
    "1405": "Omar Cook",
    "1406": "John Salmons",
    "1407": "Efthimios Rentzias",
    "1408": "Pat Burke",
    "1409": "Ryan Humphrey",
    "1410": "Carlos Boozer",
    "1411": "Smush Parker",
    "1412": "Manu Ginobili",
    "1413": "Jannero Pargo",
    "1414": "Kareem Rush",
    "1415": "Frank Williams",
    "1416": "Tayshaun Prince",
    "1417": "Mehmet Okur",
    "1418": "Jared Jeffries",
    "1419": "Juan Dixon",
    "1420": "Nate Huffman",
    "1421": "Chris Jefferies",
    "1422": "Chris Wilcox",
    "1423": "Marko Jaric",
    "1424": "Qyntel Woods",
    "1425": "Jay Williams",
    "1426": "Lonny Baxter",
    "1427": "J.R. Bremer",
    "1428": "Jiri Welsch",
    "1429": "Mike Dunleavy",
    "1430": "Nikoloz Tskitishvili",
    "1431": "Junior Harrington",
    "1432": "Igor Rakocevic",
    "1433": "Amar'e Stoudemire",
    "1434": "Casey Jacobsen",
    "1435": "Reggie Evans",
    "1436": "Dan Gadzuric",
    "1437": "Marcus Haislip",
    "1438": "Flip Murray",
    "1439": "Caron Butler",
    "1440": "Rasual Butler",
    "1441": "Drew Gooden",
    "1442": "Gordan Giricek",
    "1443": "Mike Batiste",
    "1444": "Juaquin Hawkins",
    "1445": "Yao Ming",
    "1446": "Bostjan Nachbar",
    "1447": "Fred Jones",
    "1448": "Dan Dickau",
    "1449": "Tamar Slay",
    "1450": "Guy Rucker",
    "1451": "Devin Brown",
    "1452": "Robert Archibald",
    "1453": "Adam Harrington",
    "1454": "Ken Johnson",
    "1455": "Cezary Trybanski",
    "1456": "Dajuan Wagner",
    "1457": "Predrag Savovic",
    "1458": "Tito Maddox",
    "1459": "Melvin Ely",
    "1460": "Sean Lampley",
    "1461": "Vincent Yarbrough",
    "1462": "Mike Wilks",
    "1463": "Paul Shirley",
    "1464": "Antoine Rigaudeau",
    "1465": "Jamal Sampson",
    "1466": "Roger Mason Jr.",
    "1467": "Chris Owens",
    "1468": "T.J. Ford",
    "1469": "Zoran Planinic",
    "1470": "Josh Howard",
    "1471": "Marquis Daniels",
    "1472": "Luke Walton",
    "1473": "Jerome Beasley",
    "1474": "Willie Green",
    "1475": "Zarko Cabarkapa",
    "1476": "Leandro Barbosa",
    "1477": "Keith McLeod",
    "1478": "Ndudi Ebi",
    "1479": "Boris Diaw",
    "1480": "Travis Hansen",
    "1481": "David West",
    "1482": "Chris Bosh",
    "1483": "Ben Handlogten",
    "1484": "Sasha Pavlovic",
    "1485": "Raul Lopez",
    "1486": "Mo Williams",
    "1487": "Jason Kapono",
    "1488": "Darius Songaila",
    "1489": "Mickael Pietrus",
    "1490": "Britton Johnsen",
    "1491": "Reece Gaines",
    "1492": "Michael Sweetney",
    "1493": "Marcus Banks",
    "1494": "Francisco Elson",
    "1495": "Darko Milicic",
    "1496": "Jarvis Hayes",
    "1497": "Steve Blake",
    "1498": "Torraye Braggs",
    "1499": "Chris Kaman",
    "1500": "Luke Ridnour",
    "1501": "Richie Frahm",
    "1502": "Troy Bell",
    "1503": "Kirk Penney",
    "1504": "Matt Carroll",
    "1505": "Kirk Hinrich",
    "1506": "Linton Johnson",
    "1507": "Keith Bogans",
    "1508": "Alex Garcia",
    "1509": "Maciej Lampe",
    "1510": "Theron Smith",
    "1511": "Curtis Borchardt",
    "1512": "Travis Outlaw",
    "1513": "Kendrick Perkins",
    "1514": "Dahntay Jones",
    "1515": "Kaniel Dickens",
    "1516": "Brian Cook",
    "1517": "James Jones",
    "1518": "Brandon Hunter",
    "1519": "Slavko Vranes",
    "1520": "Ronald Dupree",
    "1521": "Ime Udoka",
    "1522": "Matt Barnes",
    "1523": "Maurice Carter",
    "1524": "Desmond Penigar",
    "1525": "Hiram Fuller",
    "1526": "Josh Davis",
    "1527": "Desmond Ferguson",
    "1528": "Sasha Vujacic",
    "1529": "Carlos Delfino",
    "1530": "Kevin Martin",
    "1531": "Erik Daniels",
    "1532": "DJ Mbenga",
    "1533": "Jameer Nelson",
    "1534": "Kirk Snyder",
    "1535": "Kris Humphries",
    "1536": "Nick Collison",
    "1537": "Robert Swift",
    "1538": "Damien Wilkins",
    "1539": "Lionel Chalmers",
    "1540": "Quinton Ross",
    "1541": "Josh Smith",
    "1542": "Josh Childress",
    "1543": "Royal Ivey",
    "1544": "Jackson Vroman",
    "1545": "Yuta Tabuse",
    "1546": "Peter John Ramos",
    "1547": "Sebastian Telfair",
    "1548": "Andris Biedrins",
    "1549": "Rafael Araujo",
    "1550": "Matt Bonner",
    "1551": "Beno Udrih",
    "1552": "Tony Allen",
    "1553": "Al Jefferson",
    "1554": "David Harrison",
    "1555": "John Edwards",
    "1556": "Luke Jackson",
    "1558": "Nenad Krstic",
    "1559": "Emeka Okafor",
    "1560": "Bernard Robinson",
    "1561": "Andres Nocioni",
    "1562": "Ben Gordon",
    "1563": "Jared Reiner",
    "1564": "Chris Duhon",
    "1565": "Mario Kasun",
    "1566": "Pape Sow",
    "1567": "Geno Carlisle",
    "1568": "Awvee Storey",
    "1569": "Tim Pickett",
    "1570": "Matt Freije",
    "1571": "Andre Barrett",
    "1572": "Justin Reed",
    "1573": "Donta Smith",
    "1574": "Delonte West",
    "1575": "Horace Jenkins",
    "1576": "Corsley Edwards",
    "1577": "Antonio Burks",
    "1578": "Tony Bobbitt",
    "1579": "Luis Flores",
    "1580": "Ibrahim Kutluay",
    "1581": "Ha Ha",
    "1582": "James Thomas",
    "1583": "Andre Emmett",
    "1584": "Brandin Knight",
    "1585": "Billy Thomas",
    "1586": "Viktor Khryapa",
    "1587": "Dorell Wright",
    "1588": "Maurice Baker",
    "1589": "Pavel Podkolzin",
    "1590": "Jackie Butler",
    "1591": "Mark Jones",
    "1592": "Fabricio Oberto",
    "1593": "Andrew Bogut",
    "1594": "Deng Gai",
    "1595": "Josh Powell",
    "1596": "Dijon Thompson",
    "1597": "Francisco Garcia",
    "1598": "Ronnie Price",
    "1599": "Brandon Bass",
    "1600": "Arvydas Macijauskas",
    "1601": "Deron Williams",
    "1602": "Robert Whaley",
    "1603": "Earl Barron",
    "1604": "Wayne Simien",
    "1605": "Matt Walsh",
    "1606": "Lawrence Roberts",
    "1607": "Hakim Warrick",
    "1608": "Andrew Bynum",
    "1609": "Linas Kleiza",
    "1610": "Daniel Ewing",
    "1611": "James Singleton",
    "1612": "Yaroslav Korolev",
    "1613": "Boniface Ndong",
    "1614": "Johan Petro",
    "1615": "Sean May",
    "1616": "Sarunas Jasikevicius",
    "1617": "Danny Granger",
    "1618": "Travis Diener",
    "1619": "Jarrett Jack",
    "1620": "Martell Webster",
    "1621": "Rashad McCants",
    "1622": "Nate Robinson",
    "1623": "Ryan Gomes",
    "1624": "Orien Greene",
    "1625": "Donell Taylor",
    "1626": "Joey Graham",
    "1627": "Charlie Villanueva",
    "1628": "Jason Maxiell",
    "1629": "Luther Head",
    "1630": "Salim Stoudamire",
    "1631": "Esteban Batista",
    "1632": "Chris Taft",
    "1633": "Aaron Miles",
    "1634": "Devin Green",
    "1635": "Monta Ellis",
    "1636": "Kevin Burleson",
    "1637": "Sergei Monia",
    "1638": "Andre Owens",
    "1639": "Eddie Basden",
    "1640": "Martynas Andriuskevicius",
    "1641": "David Lee",
    "1642": "Von Wafer",
    "1643": "Andray Blatche",
    "1644": "Melvin Sanders",
    "1645": "Shavlik Randolph",
    "1646": "Sharrod Ford",
    "1647": "Alan Anderson",
    "1648": "Julius Hodge",
    "1649": "Rawle Marshall",
    "1650": "Alex Scales",
    "1651": "Gerald Fitch",
    "1652": "Ike Diogu",
    "1653": "Antoine Wright",
    "1654": "Anthony Roberson",
    "1655": "Stephen Graham",
    "1656": "John Lucas III",
    "1657": "Randy Holcomb",
    "1658": "Sean Banks",
    "1659": "Alex Acker",
    "1660": "Bracey Wright",
    "1661": "Chuck Hayes",
    "1662": "Ronny Turiaf",
    "1663": "Dwayne Jones",
    "1664": "James Lang",
    "1665": "Noel Felix",
    "1666": "Luke Schenscher",
    "1667": "Will Bynum",
    "1668": "Anthony Grundy",
    "1669": "Derrick Zimmerman",
    "1670": "Jordan Farmar",
    "1671": "Tyrus Thomas",
    "1672": "Chris Quinn",
    "1673": "Robert Hite",
    "1674": "Cedric Simmons",
    "1675": "Hilton Armstrong",
    "1676": "Leon Powe",
    "1677": "Randy Foye",
    "1678": "Craig Smith",
    "1679": "Patrick O'Bryant",
    "1680": "Damir Markota",
    "1681": "David Noel",
    "1682": "Paul Davis",
    "1683": "Renaldo Balkman",
    "1684": "Mardy Collins",
    "1685": "Alexander Johnson",
    "1686": "Steve Novak",
    "1687": "Vassilis Spanoulis",
    "1688": "Ronnie Brewer",
    "1689": "Brandon Roy",
    "1690": "Mouhamed Sene",
    "1691": "Mickael Gelabale",
    "1692": "Adam Morrison",
    "1693": "Walter Herrmann",
    "1694": "Shelden Williams",
    "1695": "Solomon Jones",
    "1696": "Cedric Bozeman",
    "1697": "Rodney Carney",
    "1698": "Ivan McFarlin",
    "1699": "Jorge Garbajosa",
    "1700": "Andrea Bargnani",
    "1701": "Marcus Williams",
    "1702": "Hassan Adams",
    "1703": "Mile Ilic",
    "1704": "Yakhouba Diawara",
    "1705": "Maurice Ager",
    "1706": "Pops Mensah-Bonsu",
    "1707": "Sergio Rodriguez",
    "1708": "Shannon Brown",
    "1709": "Dee Brown",
    "1710": "Andreas Glyniadakis",
    "1711": "Bobby Jones",
    "1712": "Roger Powell",
    "1713": "Tarence Kinsey",
    "1714": "Allan Ray",
    "1715": "Quincy Douby",
    "1716": "Daniel Gibson",
    "1717": "Marcus Vinicius",
    "1718": "Chris McCray",
    "1719": "Desmon Farmer",
    "1720": "Steven Smith",
    "1721": "Lynn Greer",
    "1722": "Uros Slokar",
    "1723": "Josh Boone",
    "1724": "Will Blalock",
    "1725": "James White",
    "1726": "Andre Brown",
    "1727": "Renaldo Major",
    "1728": "Shawne Williams",
    "1729": "James Augustine",
    "1730": "Kelenna Azubuike",
    "1731": "Justin Williams",
    "1732": "Ryan Hollins",
    "1733": "Will Conroy",
    "1734": "Jeremy Richardson",
    "1735": "Lou Amundson",
    "1736": "Randolph Morris",
    "1737": "Mike Hall",
    "1738": "Kevinn Pinkney",
    "1739": "Luis Scola",
    "1740": "Coby Karl",
    "1741": "Taurean Green",
    "1742": "Darius Washington",
    "1743": "Aaron Gray",
    "1744": "Sean Williams",
    "1745": "Yi Jianlian",
    "1746": "Nick Young",
    "1747": "Dominic McGuire",
    "1748": "Oleksiy Pecherov",
    "1749": "Courtney Sims",
    "1750": "Juan Carlos Navarro",
    "1751": "Nick Fazekas",
    "1752": "Darryl Watkins",
    "1753": "Mustafa Shakur",
    "1754": "Julian Wright",
    "1755": "DJ Strawberry",
    "1756": "Alando Tucker",
    "1757": "Arron Afflalo",
    "1758": "Daequan Cook",
    "1759": "Jermareo Davidson",
    "1760": "Acie Law",
    "1761": "Mario West",
    "1762": "Javaris Crittenton",
    "1763": "Glen Davis",
    "1765": "Chris Richard",
    "1766": "Stephane Lasme",
    "1767": "Al Thornton",
    "1768": "Brandan Wright",
    "1769": "Jamario Moon",
    "1770": "Demetris Nichols",
    "1772": "Morris Almond",
    "1773": "Gabe Pruitt",
    "1774": "Joel Anthony",
    "1775": "Spencer Hawes",
    "1776": "Brandon Wallace",
    "1777": "Aaron Brooks",
    "1778": "Cheikh Samb",
    "1779": "Kosta Perovic",
    "1780": "Thomas Gardner",
    "1781": "Carl Landry",
    "1782": "Josh McRoberts",
    "1783": "Kyrylo Fesenko",
    "1784": "Rodney Stuckey",
    "1785": "Marcus Williams",
    "1786": "Keith Langford",
    "1787": "Guillermo Diaz",
    "1788": "C.J. Watson",
    "1789": "Adam Haluska",
    "1790": "JamesOn Curry",
    "1791": "Ramon Sessions",
    "1792": "Mike Harris",
    "1793": "Lance Allred",
    "1794": "Blake Ahearn",
    "1795": "Kasib Powell",
    "1796": "JJ Hickson",
    "1797": "Joe Alexander",
    "1798": "Greg Oden",
    "1799": "Rudy Fernandez",
    "1800": "Chris Douglas-Roberts",
    "1802": "Kyle Weaver",
    "1803": "Brandon Rush",
    "1804": "Roy Hibbert",
    "1805": "DeMarcus Nelson",
    "1806": "Anthony Randolph",
    "1807": "Sean Singletary",
    "1808": "Jason Thompson",
    "1809": "Bobby Brown",
    "1810": "Mike Taylor",
    "1811": "O.J. Mayo",
    "1812": "Darrell Arthur",
    "1813": "Hamed Haddadi",
    "1814": "Joey Dorsey",
    "1815": "Roko Ukic",
    "1816": "Alexis Ajinca",
    "1817": "Sonny Weems",
    "1818": "Marreese Speights",
    "1819": "Donte Greene",
    "1820": "Walter Sharpe",
    "1821": "Rob Kurz",
    "1822": "Henry Walker",
    "1823": "Anthony Morrow",
    "1824": "Othello Hunter",
    "1825": "Steven Hill",
    "1826": "Darnell Jackson",
    "1827": "Sun Sun",
    "1828": "Jawad Williams",
    "1829": "Nathan Jawai",
    "1830": "Cartier Martin",
    "1831": "Malik Hairston",
    "1832": "J.R. Giddens",
    "1833": "Trey Johnson",
    "1834": "Joe Crawford",
    "1835": "Dontell Jefferson",
    "1836": "DJ White",
    "1837": "Chris Hunter",
    "1838": "Rodrigue Beaubois",
    "1839": "David Andersen",
    "1840": "Chase Budinger",
    "1841": "Jermaine Taylor",
    "1842": "Lester Hudson",
    "1843": "DeJuan Blair",
    "1844": "AJ Price",
    "1845": "Gerald Henderson",
    "1846": "Derrick Brown",
    "1847": "Jon Brockman",
    "1848": "Eric Maynor",
    "1849": "Ty Lawson",
    "1850": "Toney Douglas",
    "1851": "Jordan Hill",
    "1852": "Marcus Landry",
    "1853": "Austin Daye",
    "1854": "Hasheem Thabeet",
    "1855": "Sam Young",
    "1856": "Trey Gilder",
    "1857": "Earl Clark",
    "1858": "Terrence Williams",
    "1859": "Jonny Flynn",
    "1860": "Brandon Jennings",
    "1861": "DaJuan Summers",
    "1862": "Taylor Griffin",
    "1863": "Tyler Hansbrough",
    "1864": "Marcus Thornton",
    "1865": "Jeff Ayres",
    "1866": "Byron Mullens",
    "1867": "Sundiata Gaines",
    "1868": "Cedric Jackson",
    "1869": "Antonio Anderson",
    "1870": "Reggie Williams",
    "1871": "Othyus Jeffers",
    "1872": "Alonzo Gee",
    "1873": "Oliver Lafayette",
    "1874": "Kenny Hasbrouck",
    "1875": "Derrick Caracter",
    "1876": "Devin Ebanks",
    "1877": "Garret Siler",
    "1878": "Armon Johnson",
    "1879": "Luke Babbitt",
    "1880": "Semih Erden",
    "1881": "Pooh Jeter",
    "1882": "Nikola Pekovic",
    "1883": "Lazar Hayward",
    "1884": "Damion James",
    "1885": "Landry Fields",
    "1886": "Andy Rautins",
    "1887": "Sherron Collins",
    "1888": "Dominique Jones",
    "1889": "Jeff Adrien",
    "1890": "Jeremy Evans",
    "1891": "Gary Forbes",
    "1892": "Jordan Crawford",
    "1893": "Xavier Henry",
    "1894": "Larry Sanders",
    "1895": "Omer Asik",
    "1896": "Cole Aldrich",
    "1897": "James Anderson",
    "1898": "Gary Neal",
    "1899": "Manny Harris",
    "1900": "Trevor Booker",
    "1901": "Hamady Ndiaye",
    "1902": "Samardo Samuels",
    "1903": "Luke Harangody",
    "1904": "Kevin Seraphin",
    "1905": "Greivis Vasquez",
    "1906": "Tiago Splitter",
    "1907": "Willie Warren",
    "1908": "Elliot Williams",
    "1909": "Solomon Alabi",
    "1910": "Craig Brackins",
    "1911": "Ben Uzoh",
    "1912": "Gani Lawal",
    "1913": "Christian Eyenga",
    "1914": "Zabian Dowdell",
    "1915": "Larry Owens",
    "1916": "Chris Johnson",
    "1917": "Pape Sy",
    "1918": "Marcus Cousin",
    "1919": "Jerel McNeal",
    "1920": "Patrick Ewing",
    "1921": "Dexter Pittman",
    "1922": "Marqus Blakely",
    "1923": "Justin Harper",
    "1924": "JaJuan Johnson",
    "1925": "Greg Stiemsma",
    "1926": "Josh Harrellson",
    "1927": "Jerome Jordan",
    "1928": "Travis Leslie",
    "1929": "Trey Thompkins",
    "1930": "Charles Jenkins",
    "1931": "Jeremy Tyler",
    "1932": "Andrew Goudelock",
    "1933": "Norris Cole",
    "1934": "Terrel Harris",
    "1935": "Mickell Gladness",
    "1937": "Josh Selby",
    "1938": "Jimmer Fredette",
    "1939": "Tyler Honeycutt",
    "1940": "Vernon Macklin",
    "1941": "Derrick Williams",
    "1942": "Malcolm Lee",
    "1943": "Nolan Smith",
    "1944": "Darington Hobson",
    "1945": "Cory Higgins",
    "1946": "Dennis Horner",
    "1947": "Chris Singleton",
    "1948": "Carldell Johnson",
    "1949": "Ivan Johnson",
    "1950": "Chris Wright",
    "1951": "Daniel Orton",
    "1952": "Gustavo Ayon",
    "1953": "Jordan Hamilton",
    "1954": "Jan Vesely",
    "1955": "Julyan Stone",
    "1956": "Jordan Williams",
    "1957": "Darius Morris",
    "1958": "Mychel Thompson",
    "1959": "Lavoy Allen",
    "1960": "Donald Sloan",
    "1961": "Malcolm Thomas",
    "1962": "Courtney Fortson",
    "1963": "Ryan Reid",
    "1964": "Greg Smith",
    "1965": "Eric Dawson",
    "1966": "DeAndre Liggins",
    "1967": "Walker Russell",
    "1968": "Jeff Foote",
    "1969": "Jerry Smith",
    "1970": "Edwin Ubiles",
    "1971": "Justin Dentmon",
    "1972": "Keith Benson",
    "1973": "Jerome Dyson",
    "1974": "D.J. Kennedy",
    "1975": "Derrick Byars",
    "1976": "Xavier Silas",
    "1977": "Diamon Simpson",
    "1978": "Jared Sullinger",
    "1979": "Kris Joseph",
    "1981": "Bernard James",
    "1982": "Robert Sacre",
    "1984": "Kevin Murphy",
    "1985": "Victor Claver",
    "1986": "Joel Freeland",
    "1987": "Terrence Jones",
    "1989": "Royce White",
    "1990": "Kim English",
    "1991": "Kyle Singler",
    "1992": "Nando De Colo",
    "1993": "Brian Roberts",
    "1994": "Ben Hansbrough",
    "1995": "Orlando Johnson",
    "1996": "Thomas Robinson",
    "1997": "Marquis Teague",
    "1998": "Festus Ezeli",
    "1999": "Kendall Marshall",
    "2000": "Luke Zeller",
    "2001": "Quincy Miller",
    "2002": "Maalik Wayns",
    "2003": "Arnett Moultrie",
    "2004": "Tony Wroten",
    "2005": "Perry Jones III",
    "2006": "Alexey Shved",
    "2007": "John Jenkins",
    "2008": "Pablo Prigioni",
    "2009": "Chris Copeland",
    "2010": "Doron Lamb",
    "2011": "Jeffery Taylor",
    "2012": "Andrew Nicholson",
    "2013": "Tornike Shengelia",
    "2014": "Tyshawn Taylor",
    "2015": "Mirza Teletovic",
    "2016": "Scott Machado",
    "2017": "DeQuan Jones",
    "2018": "Viacheslav Kravtsov",
    "2019": "Diante Garrett",
    "2020": "Quincy Acy",
    "2021": "Darius Johnson-Odom",
    "2022": "Kevin Jones",
    "2023": "Jarvis Varnado",
    "2024": "Chris Johnson",
    "2025": "Fab Melo",
    "2026": "Tim Ohlbrecht",
    "2027": "Henry Sims",
    "2028": "Chris Wright",
    "2029": "Josh Akognon",
    "2030": "Ryan Kelly",
    "2031": "Erik Murphy",
    "2032": "Vitor Faverani",
    "2033": "Phil Pressey",
    "2034": "Dwight Buycks",
    "2035": "Elias Harris",
    "2036": "Ognjen Kuzmic",
    "2037": "Nemanja Nedovic",
    "2038": "Glen Rice",
    "2039": "Peyton Siva",
    "2040": "Tony Mitchell",
    "2041": "Gigi Datome",
    "2042": "Arinze Onuaku",
    "2043": "Jeff Withey",
    "2044": "Nate Wolters",
    "2045": "Miroslav Raduljica",
    "2046": "Nick Calathes",
    "2047": "Jamaal Franklin",
    "2049": "Pero Antic",
    "2050": "Gal Mekel",
    "2051": "Ricky Ledo",
    "2052": "Robbie Hummel",
    "2053": "Shabazz Muhammad",
    "2054": "Brandon Davies",
    "2055": "Hollis Thompson",
    "2056": "Archie Goodwin",
    "2057": "Dionte Christmas",
    "2058": "Toure' Murry",
    "2059": "James Southerland",
    "2060": "Sergey Karasev",
    "2061": "Ray McCallum",
    "2062": "Carrick Felix",
    "2063": "Chris Smith",
    "2064": "Shane Larkin",
    "2065": "Vander Blue",
    "2066": "Adonis Thomas",
    "2067": "Chris Babb",
    "2068": "Tony Mitchell",
    "2069": "Justin Hamilton",
    "2070": "Jorge Gutierrez",
    "2071": "Shane Edwards",
    "2072": "Casper Ware",
    "2073": "Scotty Hopson",
    "2074": "Willie Reed",
    "2077": "Kostas Papanikolaou",
    "2078": "PJ Hairston",
    "2079": "KJ McDaniels",
    "2081": "Damjan Rudez",
    "2082": "Shayne Whittington",
    "2083": "Cory Jefferson",
    "2084": "James Young",
    "2085": "Lucas Nogueira",
    "2086": "Jordan Adams",
    "2087": "Jarnell Stokes",
    "2088": "Tyler Ennis",
    "2089": "Cameron Bairstow",
    "2090": "Cleanthony Early",
    "2091": "Travis Wear",
    "2092": "Alex Kirk",
    "2093": "Zoran Dragic",
    "2094": "Nick Johnson",
    "2095": "Andre Dawkins",
    "2096": "Russ Smith",
    "2097": "Patric Young",
    "2098": "Will Cherry",
    "2100": "Kalin Lucas",
    "2101": "Erick Green",
    "2102": "Adreian Payne",
    "2103": "Drew Gordon",
    "2104": "Markel Brown",
    "2107": "Grant Jerrett",
    "2108": "Ronald Roberts Jr.",
    "2109": "Damien Inglis",
    "2110": "Johnny O'Bryant III",
    "2111": "Mitch McGary",
    "2112": "Furkan Aldemir",
    "2113": "Patrick Christopher",
    "2114": "Elijah Millsap",
    "2115": "Larry Drew II",
    "2116": "James Michael McAdoo",
    "2118": "Joffrey Lauvergne",
    "2119": "Jack Cooley",
    "2120": "Bryce Cotton",
    "2121": "Jerrelle Benimon",
    "2122": "Jarell Eddie",
    "2123": "Jabari Brown",
    "2124": "Sean Kilpatrick",
    "2125": "David Wear",
    "2126": "Sim Bhullar",
    "2127": "Darrun Hilliard",
    "2128": "Lamar Patterson",
    "2129": "Sasha Kaun",
    "2130": "Tibor Pleiss",
    "2131": "Rashad Vaughn",
    "2132": "Aaron Harrison",
    "2134": "Luis Montero",
    "2135": "Marcelo Huertas",
    "2136": "Anthony Brown",
    "2137": "Jordan Mickey",
    "2138": "Edy Tavares",
    "2139": "RJ Hunter",
    "2140": "Duje Dukan",
    "2141": "Cliff Alexander",
    "2142": "Josh Huestis",
    "2143": "Branden Dawson",
    "2144": "Rakeem Christmas",
    "2145": "JJ O'Brien",
    "2146": "Keith Appling",
    "2147": "Bryce Dejean-Jones",
    "2149": "Chris McCullough",
    "2150": "Alex Stepheson",
    "2152": "Briante Weber",
    "2153": "Coty Clarke",
    "2154": "Xavier Munford",
    "2155": "John Holland",
    "2156": "Mindaugas Kuzminskas",
    "2157": "Nicolas Laprovittola",
    "2159": "Joel Bolomboy",
    "2161": "Kyle Wiltjer",
    "2162": "Deyonta Davis",
    "2163": "Michael Gbinije",
    "2165": "Nicolas Brussino",
    "2166": "Paul Zipser",
    "2167": "Diamond Stone",
    "2168": "Daniel Ochefu",
    "2169": "Sheldon Mac",
    "2170": "Malcolm Delaney",
    "2171": "AJ Hammons",
    "2172": "Kay Felder",
    "2173": "Stephen Zimmerman",
    "2174": "Maurice Ndour",
    "2176": "Georgios Papagiannis",
    "2177": "Tim Quarterman",
    "2179": "Marshall Plumlee",
    "2180": "Chinanu Onuaku",
    "2181": "Pierre Jackson",
    "2182": "Okaro White",
    "2183": "Mike Tobey",
    "2184": "Marcus Georges-Hunt",
    "2185": "Brice Johnson",
    "2186": "Ben Bentil",
    "2187": "Shawn Long",
    "2191": "Patricio Garino",
    "2192": "Charles Cooke",
    "2193": "Jalen Jones",
    "2195": "Alec Peters",
    "2196": "Mike James",
    "2197": "Matt Williams Jr.",
    "2198": "Brandon Paul",
    "2199": "Dakari Johnson",
    "2200": "Mike Young",
    "2201": "Gian Clavell",
    "2203": "Mangok Mathiang",
    "2204": "Marcus Paige",
    "2205": "Jawun Evans",
    "2206": "Matt Costello",
    "2207": "Jacob Wiley",
    "2209": "Vincent Hunter",
    "2210": "Jamil Wilson",
    "2212": "Jacob Pullen",
    "2214": "Yakuba Ouattara",
    "2217": "Jamel Artis",
    "2218": "Kyle Collinsworth",
    "2220": "Reggie Hearn",
    "2221": "Nigel Hayes",
    "2224": "James Webb III",
    "2227": "Andrew White III",
    "2228": "Trey McKinney-Jones",
    "2229": "Walter Lemon Jr.",
    "2230": "Xavier Rathan-Mayes",
    "2231": "Rodney Purvis",
    "2232": "Jameel Warney",
    "2233": "Omari Johnson",
    "2234": "Andre Ingram",
    "2235": "Aaron Jackson",
    "2236": "Brian Taylor",
    "2237": "Freeman Williams",
    "2238": "Jerome Whitehead",
    "2239": "Joe Bryant",
    "2240": "Nick Weatherspoon",
    "2241": "Sidney Wicks",
    "2242": "Swen Nater",
    "2243": "World Free",
    "2244": "Don Ford",
    "2245": "Jamaal Wilkes",
    "2246": "Jim Chones",
    "2247": "Kareem Abdul-Jabbar",
    "2248": "Michael Cooper",
    "2249": "Norm Nixon",
    "2250": "Ron Boone",
    "2251": "Spencer Haywood",
    "2252": "Cedric Maxwell",
    "2253": "Chris Ford",
    "2254": "Dave Cowens",
    "2255": "Don Chaney",
    "2256": "Eric Fernsten",
    "2257": "Jeff Judkins",
    "2258": "M.L. Carr",
    "2259": "Nate Archibald",
    "2260": "Rick Robey",
    "2261": "Calvin Murphy",
    "2262": "Dwight Jones",
    "2263": "Major Jones",
    "2264": "Mike Dunleavy",
    "2265": "Rick Barry",
    "2266": "Rudy Tomjanovich",
    "2267": "Rudy White",
    "2268": "Tom Henderson",
    "2269": "Bob Dandridge",
    "2270": "Elvin Hayes",
    "2271": "Greg Ballard",
    "2272": "Kevin Grevey",
    "2273": "Kevin Porter",
    "2274": "Larry Wright",
    "2275": "Roger Phegley",
    "2276": "Wes Unseld",
    "2277": "Bobby Jones",
    "2278": "Caldwell Jones",
    "2279": "Darryl Dawkins",
    "2280": "Doug Collins",
    "2281": "Eric Money",
    "2282": "Henry Bibby",
    "2283": "Julius Erving",
    "2284": "Steve Mix",
    "2285": "Armond Hill",
    "2286": "Charlie Criss",
    "2287": "Dan Roundfield",
    "2288": "Eddie Johnson",
    "2289": "Jack Givens",
    "2290": "John Drew",
    "2291": "Ron Lee",
    "2292": "Steve Hawes",
    "2293": "Terry Furlow",
    "2294": "Tom McMillen",
    "2295": "Geoff Huston",
    "2296": "Hollis Copeland",
    "2297": "Jim Cleamons",
    "2298": "Joe Meriweather",
    "2299": "Larry Demic",
    "2300": "Micheal Ray Richardson",
    "2301": "Mike Glenn",
    "2302": "Ray Williams",
    "2303": "Sly Williams",
    "2304": "Toby Knight",
    "2305": "Abdul Jeelani",
    "2306": "Jim Brewer",
    "2307": "Jim Paxson",
    "2308": "Kermit Washington",
    "2309": "Kevin Kunnert",
    "2310": "Larry Steele",
    "2311": "Lionel Hollins",
    "2312": "Ron Brewer",
    "2313": "Tom Owens",
    "2314": "Allan Bristow",
    "2315": "Ben Poquette",
    "2316": "Don Williams",
    "2317": "Greg Deane",
    "2318": "James Hardy",
    "2319": "John Gianelli",
    "2320": "Paul Dawkins",
    "2321": "Pete Maravich",
    "2322": "Robert Smith",
    "2323": "Bob Lanier",
    "2324": "Bob McAdoo",
    "2325": "Greg Kelser",
    "2326": "Jim McElroy",
    "2327": "John Shumate",
    "2328": "Leon Douglas",
    "2329": "Phil Hubbard",
    "2330": "Roylee Hamilton",
    "2331": "Terry Duerod",
    "2332": "Terry Tyler",
    "2333": "Billy Knight",
    "2334": "Clemon Johnson",
    "2335": "Dudley Bradley",
    "2336": "Johnny Davis",
    "2337": "Mickey Johnson",
    "2338": "Mike Bantom",
    "2339": "Tony Zeno",
    "2340": "Calvin Natt",
    "2341": "Eddie Jordan",
    "2342": "George Johnson",
    "2343": "Jan Van Breda Kolff",
    "2344": "John Williamson",
    "2345": "Ralph Simpson",
    "2346": "Rich Kelley",
    "2347": "Bill Willoughby",
    "2348": "Bingo Smith",
    "2349": "Campy Russell",
    "2350": "Dave Robisch",
    "2351": "Earl Tatum",
    "2352": "John Lambert",
    "2353": "Kenny Carr",
    "2354": "Mike Mitchell",
    "2355": "Randy Smith",
    "2356": "Willie Smith",
    "2357": "Alvan Adams",
    "2358": "Alvin Scott",
    "2359": "Don Buse",
    "2360": "Garfield Heard",
    "2361": "Jeff Cook",
    "2362": "Joel Kramer",
    "2363": "Johnny High",
    "2364": "Mike Bratz",
    "2365": "Paul Westphal",
    "2366": "Truck Robinson",
    "2367": "Clifford Ray",
    "2368": "John Coughran",
    "2369": "John Lucas",
    "2370": "Jojo White",
    "2371": "Purvis Short",
    "2372": "Raymond Townsend",
    "2373": "Sonny Parker",
    "2374": "Thomas Wilson",
    "2375": "Tom Abernethy",
    "2376": "Bill Robinzine",
    "2377": "Billy McKinney",
    "2378": "Ernie Grunfeld",
    "2379": "Marlon Redmond",
    "2380": "Mike Green",
    "2381": "Otis Birdsong",
    "2382": "Phil Ford",
    "2383": "Reggie King",
    "2384": "Sam Lacey",
    "2385": "Scott Wedman",
    "2386": "Brian Winters",
    "2387": "Dave Meyers",
    "2388": "Harvey Catchings",
    "2389": "Junior Bridgeman",
    "2390": "Kent Benson",
    "2391": "Lloyd Walton",
    "2392": "Marques Johnson",
    "2393": "Quinn Buckner",
    "2394": "Richard Washington",
    "2395": "Alonzo Bradley",
    "2396": "Anthony Roberts",
    "2397": "Bo Ellis",
    "2398": "Bob Wilkerson",
    "2399": "Charlie Scott",
    "2400": "Dan Issel",
    "2401": "David Thompson",
    "2402": "Gary Garland",
    "2403": "George McGinnis",
    "2404": "John Roche",
    "2405": "Kim Hughes",
    "2406": "Austin Carr",
    "2407": "Walt Frazier",
    "2408": "Billy Paultz",
    "2409": "George Gervin",
    "2410": "Irv Kiffin",
    "2411": "James Silas",
    "2412": "Kevin Restani",
    "2413": "Larry Kenon",
    "2414": "Mark Olberding",
    "2415": "Mike Evans",
    "2416": "Mike Gale",
    "2417": "Paul Griffin",
    "2418": "Gus Bailey",
    "2419": "Phil Chenier",
    "2420": "Artis Gilmore",
    "2421": "Coby Dietrick",
    "2422": "Del Beshore",
    "2423": "Mark Landsberger",
    "2424": "Ollie Johnson",
    "2425": "Ricky Sobers",
    "2426": "Scott May",
    "2427": "Corky Calhoun",
    "2428": "Stan Pietkiewicz",
    "2429": "Dennis Johnson",
    "2430": "Fred Brown",
    "2431": "Gus Williams",
    "2432": "James Bailey",
    "2433": "John Johnson",
    "2434": "Lonnie Shelton",
    "2435": "Paul Silas",
    "2436": "Tom LaGarde",
    "2437": "Roger Brown",
    "2438": "Sammy Smith",
    "2439": "Tom Boswell",
    "2440": "Wally Walker",
    "2441": "Mike Newlin",
    "2442": "Tim Bassett",
    "2443": "Winford Boynes",
    "2444": "Bernard Toone",
    "2445": "Jim Spanarkel",
    "2446": "Gus Gerard",
    "2447": "Brad Holland",
    "2448": "Bob Carrington",
    "2449": "Dennis Awtrey",
    "2450": "Joey Hassett",
    "2451": "Foots Walker",
    "2452": "Dave Twardzik",
    "2453": "Wiley Peck",
    "2454": "John Kuester",
    "2455": "George Johnson",
    "2456": "Allen Leavell",
    "2457": "Clint Richardson",
    "2458": "Maurice Lucas",
    "2459": "Marty Byrnes",
    "2460": "Ollie Mack",
    "2461": "Bob Elliott",
    "2462": "Earl Evans",
    "2463": "John Mengelt",
    "2464": "Bob Gross",
    "2465": "Steve Malovic",
    "2466": "Andre Wakefield",
    "2467": "John Brown",
    "2468": "Terry Crosby",
    "2469": "Ron Carter",
    "2470": "John Olive",
    "2471": "Tom Burleson",
    "2472": "Mitch Kupchak",
    "2473": "Mack Calvin",
    "2474": "Len Elmore",
    "2475": "Glen Gondrezick",
    "2476": "Sam Pellom",
    "2477": "Earl Monroe",
    "2478": "Darnell Hillman",
    "2479": "Phil Smith",
    "2480": "Sylvester Norris",
    "2481": "Rick Wilson",
    "2482": "Jackie Robinson",
    "2483": "Al Skinner",
    "2484": "Bill Walton",
    "2485": "Butch Lee",
    "2486": "Marvin Barnes",
    "2487": "Phil Jackson",
    "2488": "Billyray Bates",
    "2489": "Marvin Webster",
    "2490": "Harry Davis",
    "2491": "Arvid Kramer",
    "2492": "Lawrence Boston",
    "2493": "Lynbert Johnson",
    "2494": "Ron Behagen",
    "2495": "Carl Kilpatrick",
    "2496": "Carl Nicks",
    "2497": "Cedrick Hordges",
    "2498": "Kenny Higgs",
    "2499": "Johnny Moore",
    "2500": "Reggie Johnson",
    "2501": "Kyle Macy",
    "2502": "Mike Niles",
    "2503": "Billy Reid",
    "2504": "Lorenzo Romar",
    "2505": "Rickey Brown",
    "2506": "Alan Hardy",
    "2507": "Darwin Cook",
    "2508": "Mike O'Koren",
    "2509": "Jerry Sichting",
    "2510": "Louis Orr",
    "2511": "Mike Harper",
    "2512": "Michael Brooks",
    "2513": "Calvin Garrett",
    "2514": "Keith Herron",
    "2515": "Tony Fuller",
    "2516": "Wayne Robinson",
    "2517": "Wes Matthews",
    "2518": "Charles Whitney",
    "2519": "Brett Vroman",
    "2520": "John Duren",
    "2521": "Craig Shelton",
    "2522": "Don Collins",
    "2523": "James Wilkes",
    "2524": "Sam Worthen",
    "2525": "Chad Kinch",
    "2526": "Walter Jordan",
    "2527": "Lowes Moore",
    "2528": "Darrell Allums",
    "2529": "Ralph Drollinger",
    "2530": "Reggie Carter",
    "2531": "Butch Carter",
    "2532": "Lee Johnson",
    "2533": "Kelvin Ransey",
    "2534": "Bill Hanzlik",
    "2535": "Dewayne Scales",
    "2536": "Art Collins",
    "2537": "Kenny Natt",
    "2538": "Wally Rank",
    "2539": "Monti Davis",
    "2540": "Carlos Terry",
    "2541": "Jamesearl Ray",
    "2542": "Ronnie Lester",
    "2543": "Tony Price",
    "2544": "Wayne Kreklow",
    "2545": "Andrew Toney",
    "2546": "Scott Lloyd",
    "2547": "Ron Davis",
    "2548": "Tony Jackson",
    "2549": "Dick Miller",
    "2550": "Myles Patrick",
    "2551": "Edgar Jones",
    "2552": "Michael Wiley",
    "2553": "Ron Valentine",
    "2554": "Jeff Wilkins",
    "2555": "John Stroud",
    "2556": "Norman Black",
    "2557": "David Britton",
    "2558": "Keith McCord",
    "2559": "Andre McCarter",
    "2560": "Lewis Brown",
    "2561": "Mel Bennett",
    "2562": "Frankie Sanders",
    "2563": "Jacky Dorsey",
    "2564": "Ed Lawrence",
    "2565": "Jeffrey Crompton",
    "2566": "Clarence Kea",
    "2567": "Bill Mayfield",
    "2568": "Peter Verhoeven",
    "2569": "Franklin Edwards",
    "2570": "Mickey Dillard",
    "2571": "Roger Burkman",
    "2572": "Joe Cooper",
    "2573": "Ray Tolbert",
    "2574": "Charles Bradley",
    "2575": "Tracy Jackson",
    "2576": "Charlie Davis",
    "2577": "Garry Witts",
    "2578": "Kevin Loder",
    "2579": "Gene Banks",
    "2580": "Bobby Cattage",
    "2581": "Howard Wood",
    "2582": "Elston Turner",
    "2583": "Jay Vincent",
    "2584": "Kevin McKenna",
    "2585": "Hank McDowell",
    "2586": "Samuel Williams",
    "2587": "Danny Vranes",
    "2588": "Ed Rains",
    "2589": "Rudy Macklin",
    "2590": "Jim Smith",
    "2591": "John Douglas",
    "2592": "Jeff Lamp",
    "2593": "Alex Bradley",
    "2594": "Ray Blume",
    "2595": "Mike McGee",
    "2596": "Craig Dykema",
    "2597": "John McCullough",
    "2598": "David Burns",
    "2599": "Kurt Nimphius",
    "2600": "Lewis Lloyd",
    "2601": "Jim Brogan",
    "2602": "Glenn Hagan",
    "2603": "Petur Gudmundsson",
    "2604": "Mark Radford",
    "2605": "Al Wood",
    "2606": "Kevin Stacom",
    "2607": "Steve Hayes",
    "2608": "Kenny Dennard",
    "2609": "Rich Yonakor",
    "2610": "Larry Spriggs",
    "2611": "Brad Branson",
    "2612": "Clay Johnson",
    "2613": "Carl Bailey",
    "2614": "Rock Lee",
    "2615": "Edmund Sherod",
    "2616": "Eddie Phillips",
    "2617": "Richard Anderson",
    "2618": "David Thirdkill",
    "2619": "Rory White",
    "2620": "Jerry Eaves",
    "2621": "Brook Steppe",
    "2622": "Audie Norris",
    "2623": "Bruce Flowers",
    "2624": "Dave Magley",
    "2625": "Darren Tillis",
    "2626": "Jeff Taylor",
    "2627": "Chris Engler",
    "2628": "Clark Kellogg",
    "2629": "Bryan Warrick",
    "2630": "Rob Williams",
    "2631": "Bill Garnett",
    "2632": "Vince Taylor",
    "2633": "Marc Iavaroni",
    "2634": "Mitchell Anderson",
    "2635": "Russ Schoene",
    "2636": "Dave Batton",
    "2637": "Rickey Williams",
    "2638": "Walker Russell",
    "2639": "Jim Zoet",
    "2640": "Keith Edmonson",
    "2641": "Steve Lingenfelter",
    "2642": "Guy Morgan",
    "2643": "Jose Slaughter",
    "2644": "Linton Townes",
    "2645": "Jim Johnstone",
    "2646": "Oliver Robinson",
    "2647": "Willie Jones",
    "2648": "Corny Thompson",
    "2649": "Dwight Anderson",
    "2650": "John Cox",
    "2651": "Charlie Pittman",
    "2652": "John Greig",
    "2653": "Joe Kopicki",
    "2654": "Michael Davis",
    "2655": "Moses Malone",
    "2656": "Howard Carter",
    "2657": "Bruce Kuczenski",
    "2658": "John Pinone",
    "2659": "Darren Daye",
    "2660": "Mike Wilson",
    "2661": "Scooter McCray",
    "2662": "Pace Mannion",
    "2663": "Paul Thompson",
    "2664": "Granville Waiters",
    "2665": "Leroy Combs",
    "2666": "Sidney Lowe",
    "2667": "Steve Stipanovich",
    "2668": "Kevin Williams",
    "2669": "John Garris",
    "2670": "Stewart Granger",
    "2671": "Carlos Clark",
    "2672": "Leo Rautins",
    "2673": "Rod Foster",
    "2674": "Dane Suttle",
    "2675": "Darrell Lockhart",
    "2676": "Mark Jones",
    "2677": "Larry Micheaux",
    "2678": "Mike Gibson",
    "2679": "Ken Austin",
    "2680": "Tom Piotrowski",
    "2681": "Russell Cross",
    "2682": "Wallace Bryant",
    "2683": "Bob Miller",
    "2684": "Brant Weidner",
    "2685": "Cory Blackwell",
    "2686": "Mel Turpin",
    "2687": "Chuck Aleksinas",
    "2688": "Othell Wilson",
    "2689": "Peter Thibeaux",
    "2690": "Michael Holton",
    "2691": "Wayne Sappleton",
    "2692": "Tom Sewell",
    "2693": "Kenny Fields",
    "2694": "Devin Durrant",
    "2695": "Ozell Jones",
    "2696": "Lancaster Gordon",
    "2697": "Bernard Thompson",
    "2698": "Charles Jones",
    "2699": "Tom Scheffler",
    "2700": "Willie White",
    "2701": "Guy Williams",
    "2702": "Charlie Sitton",
    "2703": "Terence Stansbury",
    "2704": "Rick Carlisle",
    "2705": "Dale Wilkinson",
    "2706": "Jay Murphy",
    "2707": "Tom Sluby",
    "2708": "Earl Jones",
    "2709": "Ralph Jackson",
    "2710": "Ron Cavenall",
    "2711": "John Schweitz",
    "2712": "Michael Young",
    "2713": "David Pope",
    "2714": "Kent Edelin",
    "2715": "Butch Graves",
    "2716": "Dirk Minniefield",
    "2717": "Lorenzo Charles",
    "2718": "Perry Moss",
    "2719": "Carey Scurry",
    "2720": "Steve Harris",
    "2721": "Carl Henry",
    "2722": "David Cooke",
    "2723": "Ron Crevier",
    "2724": "Bill Martin",
    "2725": "Dwayne McClain",
    "2726": "Yvon Joseph",
    "2727": "Uwe Blab",
    "2728": "Mike Phelps",
    "2729": "Alfredrick Hughes",
    "2730": "Ken Johnson",
    "2731": "Pete Williams",
    "2732": "Kenny Green",
    "2733": "Brian Martin",
    "2734": "Mike Brittain",
    "2735": "Fred Cofield",
    "2736": "Georgi Glouchkov",
    "2737": "Greg Stokes",
    "2738": "Voise Winters",
    "2739": "Keith Lee",
    "2740": "Harold Keeling",
    "2741": "Claude Gregory",
    "2742": "Jeff Cross",
    "2743": "Chris McNealy",
    "2744": "Ben McDonald",
    "2745": "Jerome Henderson",
    "2746": "Derrick Rowland",
    "2747": "Nick Vanos",
    "2748": "Ken Green",
    "2749": "Myron Jackson",
    "2750": "Mo Martin",
    "2751": "Anthony Jones",
    "2752": "Fernando Martin",
    "2753": "Walter Berry",
    "2754": "Keith Smith",
    "2755": "Dwayne Washington",
    "2756": "Mckinley Singleton",
    "2757": "Grant Gondrezick",
    "2758": "Chris Washburn",
    "2759": "Bruce Douglas",
    "2760": "Johnny Rogers",
    "2761": "Cedric Henderson",
    "2762": "Conner Henry",
    "2763": "Dwayne Polee",
    "2764": "Steffond Johnson",
    "2765": "Adrian Branch",
    "2766": "Harold Pressley",
    "2767": "Forrest McKenzie",
    "2768": "Curtis Kitchen",
    "2769": "Jim Lampley",
    "2770": "Dennis Nutt",
    "2771": "Cozell McQueen",
    "2772": "Perry Young",
    "2773": "Kevin Henderson",
    "2774": "Joe Binion",
    "2775": "Ron Rowan",
    "2776": "Brad Wright",
    "2777": "Ralph Lewis",
    "2778": "John Stroeder",
    "2779": "Nikita Wilson",
    "2780": "Dallas Comegys",
    "2781": "Jamie Waller",
    "2782": "Andre Moore",
    "2783": "Martin Nessley",
    "2784": "Norris Coleman",
    "2785": "Chris Welp",
    "2786": "Nate Blackwell",
    "2787": "Joe Arlauckas",
    "2788": "Michael Jackson",
    "2789": "Clinton Wheeler",
    "2790": "Ron Moore",
    "2791": "Tony White",
    "2792": "Kannard Johnson",
    "2793": "Winston Crite",
    "2794": "Rickie Winslow",
    "2795": "Brian Rowsom",
    "2796": "Billy Donovan",
    "2797": "Ronnie Murphy",
    "2798": "Scott Roth",
    "2799": "Ricky Wilson",
    "2800": "Dave Henderson",
    "2801": "Phil Zevenbergen",
    "2802": "Eddie Hughes",
    "2803": "Eric White",
    "2804": "Mark Wade",
    "2805": "Richard Rellford",
    "2806": "Richard Morton",
    "2807": "Mark Davis",
    "2808": "Wayne Englestad",
    "2809": "Rolando Ferreira",
    "2810": "Dominic Pressley",
    "2811": "Anthony Taylor",
    "2812": "Sylvester Gray",
    "2813": "Ben Gillery",
    "2814": "Ricky Berry",
    "2815": "Ramon Rivas",
    "2816": "Keith Smart",
    "2817": "Shelton Jones",
    "2818": "Jose Ortiz",
    "2819": "Fennis Dembo",
    "2820": "Todd Mitchell",
    "2821": "Robert Lock",
    "2822": "Michael Anderson",
    "2823": "Bill Jones",
    "2824": "Jim Rowinski",
    "2825": "Mike Champion",
    "2826": "Randy Allen",
    "2827": "Orlando Graham",
    "2828": "Robert Rose",
    "2829": "Barry Sumpter",
    "2830": "Terry Dozier",
    "2831": "Ed Horton",
    "2832": "Torgeir Bryn",
    "2833": "Jay Taylor",
    "2834": "Stanley Brundy",
    "2835": "Dyron Nix",
    "2836": "Leonard Taylor",
    "2837": "Steve Bucknall",
    "2838": "Eric Johnson",
    "2839": "Mel McCants",
    "2840": "Gary Voce",
    "2841": "Nate Johnston",
    "2842": "Jeff Lebo",
    "2843": "Zarko Paspalj",
    "2844": "Dexter Shouse",
    "2845": "Mike Morrison",
    "2846": "Doug Roth",
    "2847": "Mike Williams",
    "2848": "Jay Edwards",
    "2849": "Raymond Brown",
    "2850": "Dee Brown",
    "2851": "Larry Bird",
    "2852": "Reggie Lewis",
    "2853": "Ed Pinckney",
    "2854": "Kevin McHale",
    "2855": "Joe Kleine",
    "2856": "Kevin Gamble",
    "2857": "Brian Shaw",
    "2858": "Dave Popson",
    "2859": "Robert Parish",
    "2860": "Brad Daugherty",
    "2861": "Chucky Brown",
    "2862": "Craig Ehlo",
    "2863": "Danny Ferry",
    "2864": "Derrick Chievous",
    "2865": "Gerald Paddio",
    "2866": "Hot Rod,Williams",
    "2867": "Spud Webb",
    "2868": "Jerry Reynolds",
    "2869": "Mark Aguirre",
    "2870": "Fred Roberts",
    "2871": "John Stockton",
    "2872": "Eddie Johnson",
    "2873": "Terry Porter",
    "2874": "Mike Woodson",
    "2875": "Jim Thomas",
    "2876": "Brad Davis",
    "2877": "Orlando Woolridge",
    "2878": "Chris Mullin",
    "2879": "Rony Seikaly",
    "2880": "Harvey Grant",
    "2881": "Chuck Person",
    "2882": "Detlef Schrempf",
    "2883": "George McCloud",
    "2884": "Greg Dreiling",
    "2885": "Kenny Williams",
    "2886": "LaSalle Thompson",
    "2887": "Micheal Williams",
    "2888": "Mike Sanders",
    "2889": "Randy Wittman",
    "2890": "Reggie Miller",
    "2891": "Rik Smits",
    "2892": "Vern Fleming",
    "2893": "Chris Dudley",
    "2894": "Chris Morris",
    "2895": "Derrick Coleman",
    "2896": "Derrick Gervin",
    "2897": "Jack Haley",
    "2898": "Jud Buechler",
    "2899": "Kurk Lee",
    "2900": "Lester Conner",
    "2901": "Mookie Blaylock",
    "2902": "Reggie Theus",
    "2903": "Sam Bowie",
    "2904": "Tate George",
    "2905": "Bo Kimble",
    "2906": "Charles Smith",
    "2907": "Gary Grant",
    "2908": "Jeff Martin",
    "2909": "Ken Bannister",
    "2910": "Ken Norman",
    "2911": "Loy Vaught",
    "2912": "Tom Garrick",
    "2913": "Winston Garland",
    "2914": "Antoine Carr",
    "2915": "Bill Wennington",
    "2916": "Bob Hansen",
    "2917": "Duane Causwell",
    "2918": "Eric Leckner",
    "2919": "Lionel Simmons",
    "2920": "Ralph Sampson",
    "2921": "Rory Sparrow",
    "2922": "Steve Colter",
    "2923": "Wayman Tisdale",
    "2924": "B.J. Armstrong",
    "2925": "Bill Cartwright",
    "2926": "Cliff Levingston",
    "2927": "Craig Hodges",
    "2928": "Dennis Hopson",
    "2929": "Horace Grant",
    "2930": "John Paxson",
    "2931": "Michael Jordan",
    "2932": "Scott Williams",
    "2933": "Scottie Pippen",
    "2934": "Stacey King",
    "2935": "Will Perdue",
    "2936": "Brian Oliver",
    "2937": "Charles Barkley",
    "2938": "Hersey Hawkins",
    "2939": "Jayson Williams",
    "2940": "Johnny Dawkins",
    "2941": "Manute Bol",
    "2942": "Mike Gminski",
    "2943": "Rick Mahorn",
    "2944": "Rickey Green",
    "2945": "Ron Anderson",
    "2946": "Armen Gilliam",
    "2947": "Dave Hoppen",
    "2948": "Dell Curry",
    "2949": "J.R. Reid",
    "2950": "Johnny Newman",
    "2951": "Kelly Tripucka",
    "2952": "Kendall Gill",
    "2953": "Kenny Gattison",
    "2954": "Muggsy Bogues",
    "2955": "Rex Chapman",
    "2956": "Brian Quinnett",
    "2957": "Charles Oakley",
    "2958": "Eddielee Wilkins",
    "2959": "Gerald Wilkins",
    "2960": "Jerrod Mustaf",
    "2961": "Kiki Vandeweghe",
    "2962": "Mark Jackson",
    "2963": "Maurice Cheeks",
    "2964": "Patrick Ewing",
    "2965": "Mark Bryant",
    "2966": "Dana Barros",
    "2967": "Derrick McKey",
    "2968": "Gary Payton",
    "2969": "Michael Cage",
    "2970": "Olden Polynice",
    "2971": "Quintin Dailey",
    "2972": "Sedale Threatt",
    "2973": "Shawn Kemp",
    "2974": "Xavier McDaniel",
    "2975": "Tree Rollins",
    "2976": "Pervis Ellison",
    "2977": "Stuart Gray",
    "2978": "Trent Tucker",
    "2979": "Frank Kornet",
    "2980": "David Greenwood",
    "2981": "David Robinson",
    "2982": "Paul Pressey",
    "2983": "Reggie Williams",
    "2984": "Sean Elliott",
    "2985": "Sean Higgins",
    "2986": "Sidney Green",
    "2987": "Terry Cummings",
    "2988": "Tony Massenburg",
    "2989": "A.C. Green",
    "2990": "Byron Scott",
    "2991": "Elden Campbell",
    "2992": "James Worthy",
    "2993": "Larry Drew",
    "2994": "Magic Johnson",
    "2995": "Mychal Thompson",
    "2996": "Sam Perkins",
    "2997": "Terry Teagle",
    "2998": "Vlade Divac",
    "2999": "John Shasky",
    "3000": "Randy White",
    "3001": "Steve Alford",
    "3002": "Greg Butler",
    "3003": "Steve Scheffler",
    "3004": "Les Jepsen",
    "3005": "Mike Smrek",
    "3006": "Danny Manning",
    "3007": "Mark McNamara",
    "3008": "Steve Kerr",
    "3009": "Kennard Winchester",
    "3010": "Rick Calloway",
    "3011": "Travis Mays",
    "3012": "Trevor Wilson",
    "3013": "Tony Brown",
    "3014": "Randolph Keys",
    "3015": "Benoit Benjamin",
    "3016": "Byron Dinkins",
    "3017": "Dwayne Schintzius",
    "3018": "Kenny Payne",
    "3019": "Greg Grant",
    "3020": "Tony Smith",
    "3021": "Nate McMillan",
    "3022": "Rod Strickland",
    "3023": "Mahmoud Abdul-Rauf",
    "3024": "Scott Meents",
    "3025": "Jim Petersen",
    "3026": "Bob Thornton",
    "3027": "Drazen Petrovic",
    "3028": "Kurt Rambis",
    "3029": "Jon Koncak",
    "3030": "Stojko Vrankovic",
    "3031": "Cedric Ball",
    "3032": "Andrew Lang",
    "3033": "Bart Kofoed",
    "3034": "Jim Farmer",
    "3035": "Dave Corzine",
    "3036": "Buck Johnson",
    "3037": "Milos Babic",
    "3038": "Negele Knight",
    "3039": "Willie Anderson",
    "3040": "Andre Turner",
    "3041": "Ledell Eackles",
    "3042": "Jim Grandholm",
    "3043": "Kelvin Upshaw",
    "3044": "Leon Wood",
    "3045": "Terry Mills",
    "3046": "Darnell Valentine",
    "3047": "Morlon Wiley",
    "3048": "Irving Thomas",
    "3049": "John Starks",
    "3050": "Pete Myers",
    "3051": "Keith Askins",
    "3052": "Anthony Bonner",
    "3053": "Dale Ellis",
    "3054": "Pat Cummings",
    "3055": "Kenny Walker",
    "3056": "Mario Elie",
    "3057": "Anthony Mason",
    "3058": "Tim Legler",
    "3059": "Dan O'Sullivan",
    "3060": "Dan Godfread",
    "3061": "Henry James",
    "3062": "Jim Les",
    "3063": "Paul Mokeski",
    "3064": "Earl Cureton",
    "3065": "Anthony Frederick",
    "3066": "Jawann Oldham",
    "3067": "Jeff Sanders",
    "3068": "Scott Haffner",
    "3069": "John Long",
    "3070": "Ron Harper",
    "3071": "Tony Harris",
    "3072": "Clifford Lett",
    "3073": "Clinton Smith",
    "3074": "John Williams",
    "3075": "Craig Neal",
    "3076": "Mike Higgins",
    "3077": "Joe Barry,Carroll",
    "3078": "Gerald Henderson",
    "3079": "Everette Stephens",
    "3080": "Charles Smith",
    "3081": "David Wingate",
    "3082": "Tony Dawson",
    "3083": "Gary Leonard",
    "3084": "A.J. Wynder",
    "3085": "Adrian Dantley",
    "3086": "Derek Smith",
    "3087": "Vincent Askew",
    "3088": "Robert Reid",
    "5117": "Mitchell Creek",
    "50191": "Bonzie Colson",
    "24102396": "Trevon Scott",
    "2": "Jaylen Adams",
    "3": "Steven Adams",
    "4": "Bam Adebayo",
    "5": "DeVaughn Akoon-Purcell",
    "6": "LaMarcus Aldridge",
    "7": "Rawle Alkins",
    "8": "Grayson Allen",
    "9": "Jarrett Allen",
    "10": "Al-Farouq Aminu",
    "11": "Justin Anderson",
    "12": "Kyle Anderson",
    "13": "Ryan Anderson",
    "15": "Giannis Antetokounmpo",
    "16": "Kostas Antetokounmpo",
    "17": "Carmelo Anthony",
    "18": "OG Anunoby",
    "19": "Ryan Arcidiacono",
    "20": "Trevor Ariza",
    "21": "D.J. Augustin",
    "22": "Deandre Ayton",
    "23": "Dwayne Bacon",
    "24": "Marvin Bagley III",
    "27": "Lonzo Ball",
    "28": "Mo Bamba",
    "29": "J.J. Barea",
    "30": "Harrison Barnes",
    "31": "Will Barton",
    "32": "Keita Bates-Diop",
    "33": "Nicolas Batum",
    "35": "Aron Baynes",
    "36": "Kent Bazemore",
    "37": "Bradley Beal",
    "38": "Malik Beasley",
    "40": "Marco Belinelli",
    "41": "Jordan Bell",
    "42": "DeAndre' Bembry",
    "43": "Dragan Bender",
    "44": "Davis Bertans",
    "45": "Patrick Beverley",
    "46": "Khem Birch",
    "48": "Bismack Biyombo",
    "49": "Nemanja Bjelica",
    "50": "Antonio Blakeney",
    "51": "Eric Bledsoe",
    "52": "Trevon Bluiett",
    "53": "Bogdan Bogdanovic",
    "54": "Bojan Bogdanovic",
    "55": "Jonah Bolden",
    "56": "Isaac Bonga",
    "57": "Devin Booker",
    "58": "Chris Boucher",
    "59": "Avery Bradley",
    "60": "Tony Bradley",
    "61": "Mikal Bridges",
    "62": "Miles Bridges",
    "64": "Ryan Broekhoff",
    "65": "Malcolm Brogdon",
    "66": "Dillon Brooks",
    "68": "Troy Brown Jr.",
    "69": "Bruce Brown",
    "70": "Jaylen Brown",
    "72": "Sterling Brown",
    "73": "Jalen Brunson",
    "74": "Thomas Bryant",
    "75": "Reggie Bullock",
    "76": "Trey Burke",
    "77": "Alec Burks",
    "78": "Deonte Burton",
    "79": "Jimmy Butler",
    "81": "Kentavious Caldwell-Pope",
    "83": "Clint Capela",
    "84": "DeMarre Carroll",
    "85": "Wendell Carter Jr.",
    "86": "Michael Carter-Williams",
    "87": "Jevon Carter",
    "88": "Vince Carter",
    "89": "Alex Caruso",
    "91": "Willie Cauley-Stein",
    "92": "Troy Caupain",
    "94": "Tyson Chandler",
    "95": "Wilson Chandler",
    "96": "Joe Chealey",
    "97": "Marquese Chriss",
    "98": "Gary Clark",
    "100": "Jordan Clarkson",
    "101": "John Collins",
    "102": "Zach Collins",
    "103": "Darren Collison",
    "104": "Mike Conley",
    "105": "Pat Connaughton",
    "106": "Quinn Cook",
    "107": "DeMarcus Cousins",
    "108": "Robert Covington",
    "109": "Allen Crabbe",
    "110": "Torrey Craig",
    "111": "Jamal Crawford",
    "112": "Jae Crowder",
    "114": "Seth Curry",
    "115": "Stephen Curry",
    "116": "Troy Daniels",
    "117": "Anthony Davis",
    "118": "Ed Davis",
    "120": "Dewayne Dedmon",
    "121": "Sam Dekker",
    "123": "Matthew Dellavedova",
    "125": "DeMar DeRozan",
    "126": "Marcus Derrickson",
    "127": "Cheick Diallo",
    "128": "Hamidou Diallo",
    "129": "Gorgui Dieng",
    "130": "Spencer Dinwiddie",
    "131": "Donte DiVincenzo",
    "132": "Luka Doncic",
    "133": "Tyler Dorsey",
    "134": "Damyean Dotson",
    "135": "PJ Dozier",
    "136": "Goran Dragic",
    "137": "Andre Drummond",
    "138": "Jared Dudley",
    "139": "Kris Dunn",
    "140": "Kevin Durant",
    "143": "Henry Ellenson",
    "144": "Wayne Ellington",
    "145": "Joel Embiid",
    "146": "James Ennis III",
    "147": "Drew Eubanks",
    "148": "Jacob Evans",
    "151": "Dante Exum",
    "152": "Kenneth Faried",
    "153": "Derrick Favors",
    "154": "Cristiano Felicio",
    "156": "Terrance Ferguson",
    "157": "Yogi Ferrell",
    "158": "Dorian Finney-Smith",
    "159": "Bryn Forbes",
    "160": "Evan Fournier",
    "161": "De'Aaron Fox",
    "162": "Melvin Frazier Jr.",
    "163": "Tim Frazier",
    "164": "Channing Frye",
    "165": "Markelle Fultz",
    "166": "Wenyen Gabriel",
    "167": "Danilo Gallinari",
    "168": "Langston Galloway",
    "169": "Marc Gasol",
    "170": "Pau Gasol",
    "171": "Rudy Gay",
    "172": "Paul George",
    "173": "Taj Gibson",
    "174": "Harry Giles III",
    "175": "Shai Gilgeous-Alexander",
    "176": "Rudy Gobert",
    "177": "Aaron Gordon",
    "178": "Eric Gordon",
    "180": "Devonte' Graham",
    "181": "Treveon Graham",
    "182": "Jerami Grant",
    "183": "Jerian Grant",
    "184": "Danny Green",
    "185": "Draymond Green",
    "186": "Gerald Green",
    "187": "JaMychal Green",
    "188": "Jeff Green",
    "189": "Blake Griffin",
    "190": "Daniel Hamilton",
    "191": "Tim Hardaway Jr.",
    "192": "James Harden",
    "193": "Maurice Harkless",
    "194": "Montrezl Harrell",
    "195": "Devin Harris",
    "196": "Gary Harris",
    "197": "Joe Harris",
    "198": "Andrew Harrison",
    "199": "Shaquille Harrison",
    "200": "Tobias Harris",
    "201": "Isaiah Hartenstein",
    "202": "Josh Hart",
    "203": "Udonis Haslem",
    "204": "Gordon Hayward",
    "205": "John Henson",
    "206": "Juancho Hernangomez",
    "207": "Willy Hernangomez",
    "208": "Mario Hezonja",
    "209": "Isaiah Hicks",
    "210": "Buddy Hield",
    "211": "George Hill",
    "212": "Solomon Hill",
    "213": "Aaron Holiday",
    "214": "Jrue Holiday",
    "215": "Justin Holiday",
    "216": "Rondae Hollis-Jefferson",
    "217": "Richaun Holmes",
    "218": "Rodney Hood",
    "219": "Al Horford",
    "220": "Dwight Howard",
    "221": "Kevin Huerter",
    "222": "Chandler Hutchison",
    "223": "Serge Ibaka",
    "224": "Andre Iguodala",
    "225": "Ersan Ilyasova",
    "226": "Joe Ingles",
    "227": "Brandon Ingram",
    "228": "Kyrie Irving",
    "229": "Jonathan Isaac",
    "230": "Wes Iwundu",
    "231": "Jaren Jackson Jr.",
    "232": "Demetrius Jackson",
    "233": "Frank Jackson",
    "234": "Josh Jackson",
    "235": "Justin Jackson",
    "236": "Reggie Jackson",
    "237": "LeBron James",
    "238": "Amile Jefferson",
    "239": "Jonas Jerebko",
    "240": "Alize Johnson",
    "242": "James Johnson",
    "243": "Stanley Johnson",
    "244": "Tyler Johnson",
    "246": "Nikola Jokic",
    "247": "Derrick Jones Jr.",
    "248": "Damian Jones",
    "249": "Tyus Jones",
    "250": "DeAndre Jordan",
    "251": "Cory Joseph",
    "252": "Frank Kaminsky",
    "253": "Enes Kanter",
    "254": "Luke Kennard",
    "255": "Michael Kidd-Gilchrist",
    "256": "George King",
    "257": "Maxi Kleber",
    "258": "Brandon Knight",
    "259": "Kevin Knox",
    "260": "Furkan Korkmaz",
    "261": "Luke Kornet",
    "262": "Kyle Korver",
    "264": "Rodions Kurucs",
    "265": "Kyle Kuzma",
    "266": "Skal Labissiere",
    "267": "Jeremy Lamb",
    "268": "Zach LaVine",
    "269": "Jake Layman",
    "270": "TJ Leaf",
    "271": "Courtney Lee",
    "272": "Damion Lee",
    "273": "Alex Len",
    "274": "Kawhi Leonard",
    "275": "Meyers Leonard",
    "277": "Caris LeVert",
    "278": "Damian Lillard",
    "282": "Kevon Looney",
    "283": "Brook Lopez",
    "284": "Robin Lopez",
    "285": "Kevin Love",
    "286": "Kyle Lowry",
    "288": "Timothe Luwawu-Cabarrot",
    "289": "Tyler Lydon",
    "290": "Trey Lyles",
    "291": "Shelvin Mack",
    "292": "Daryl Macon",
    "293": "J.P. Macura",
    "294": "Ian Mahinmi",
    "295": "Thon Maker",
    "296": "Boban Marjanovic",
    "297": "Lauri Markkanen",
    "298": "Jarell Martin",
    "299": "Frank Mason",
    "300": "Yante Maten",
    "301": "Wesley Matthews",
    "302": "Luc Mbah a Moute",
    "303": "CJ McCollum",
    "304": "T.J. McConnell",
    "305": "Doug McDermott",
    "306": "JaVale McGee",
    "307": "Rodney McGruder",
    "308": "Alfonzo McKinnie",
    "309": "Ben McLemore",
    "310": "Jordan McRae",
    "311": "Jodie Meeks",
    "312": "Salah Mejri",
    "313": "De'Anthony Melton",
    "314": "Chimezie Metu",
    "315": "Khris Middleton",
    "316": "CJ Miles",
    "317": "Darius Miller",
    "318": "Paul Millsap",
    "319": "Patty Mills",
    "320": "Shake Milton",
    "321": "Nikola Mirotic",
    "322": "Donovan Mitchell",
    "323": "Naz Mitrou-Long",
    "324": "Malik Monk",
    "325": "Greg Monroe",
    "326": "E'Twaun Moore",
    "327": "Jaylen Morris",
    "328": "Marcus Morris",
    "329": "Markieff Morris",
    "330": "Monte Morris",
    "331": "Johnathan Motley",
    "332": "Timofey Mozgov",
    "333": "Emmanuel Mudiay",
    "334": "Dejounte Murray",
    "335": "Jamal Murray",
    "336": "Dzanan Musa",
    "337": "Mike Muscala",
    "338": "Svi Mykhailiuk",
    "339": "Abdel Nader",
    "340": "Larry Nance Jr.",
    "341": "Shabazz Napier",
    "342": "Nene ",
    "343": "Raul Neto",
    "344": "Georges Niang",
    "345": "Nerlens Noel",
    "346": "Dirk Nowitzki",
    "347": "Frank Ntilikina",
    "348": "James Nunnally",
    "349": "Jusuf Nurkic",
    "350": "David Nwaba",
    "351": "Royce O'Neale",
    "352": "Kyle O'Quinn",
    "353": "Semi Ojeleye",
    "354": "Jahlil Okafor",
    "355": "Elie Okobo",
    "356": "Josh Okogie",
    "357": "Victor Oladipo",
    "358": "Kelly Olynyk",
    "359": "Cedi Osman",
    "360": "Kelly Oubre Jr.",
    "361": "Zaza Pachulia",
    "362": "Jabari Parker",
    "363": "Tony Parker",
    "364": "Chandler Parsons",
    "365": "Patrick Patterson",
    "366": "Justin Patton",
    "367": "Chris Paul",
    "368": "Cameron Payne",
    "369": "Elfrid Payton",
    "370": "Theo Pinson",
    "371": "Mason Plumlee",
    "372": "Miles Plumlee",
    "373": "Jakob Poeltl",
    "374": "Quincy Pondexter",
    "375": "Michael Porter Jr.",
    "376": "Otto Porter Jr.",
    "377": "Bobby Portis",
    "378": "Kristaps Porzingis",
    "379": "Dwight Powell",
    "380": "Norman Powell",
    "381": "Alex Poythress",
    "383": "Taurean Prince",
    "385": "Ivan Rabb",
    "386": "Chasson Randle",
    "387": "Julius Randle",
    "389": "JJ Redick",
    "390": "Davon Reed",
    "391": "Josh Richardson",
    "393": "Austin Rivers",
    "394": "Andre Roberson",
    "395": "Glenn Robinson III",
    "396": "Devin Robinson",
    "397": "Duncan Robinson",
    "398": "Jerome Robinson",
    "399": "Mitchell Robinson",
    "400": "Rajon Rondo",
    "401": "Derrick Rose",
    "402": "Terrence Ross",
    "403": "Terry Rozier",
    "404": "Ricky Rubio",
    "405": "D'Angelo Russell",
    "406": "Domantas Sabonis",
    "407": "Dario Saric",
    "408": "Tomas Satoransky",
    "409": "Dennis Schroder",
    "410": "Mike Scott",
    "411": "Thabo Sefolosha",
    "412": "Wayne Selden",
    "413": "Collin Sexton",
    "414": "Landry Shamet",
    "415": "Iman Shumpert",
    "416": "Pascal Siakam",
    "417": "Ben Simmons",
    "418": "Jonathon Simmons",
    "419": "Anfernee Simons",
    "420": "Marcus Smart",
    "421": "Dennis Smith Jr.",
    "422": "Ish Smith",
    "424": "JR Smith",
    "425": "Zhaire Smith",
    "426": "Tony Snell",
    "427": "Ray Spalding",
    "428": "Omari Spellman",
    "429": "Nik Stauskas",
    "431": "Lance Stephenson",
    "432": "Edmond Sumner",
    "433": "Caleb Swanigan",
    "434": "Jayson Tatum",
    "435": "Jeff Teague",
    "436": "Garrett Temple",
    "439": "Daniel Theis",
    "440": "Isaiah Thomas",
    "441": "Khyri Thomas",
    "442": "Lance Thomas",
    "443": "Klay Thompson",
    "444": "Tristan Thompson",
    "445": "Sindarius Thornwell",
    "446": "Anthony Tolliver",
    "447": "Karl-Anthony Towns",
    "449": "Allonzo Trier",
    "450": "PJ Tucker",
    "451": "Evan Turner",
    "452": "Myles Turner",
    "453": "Ekpe Udoh",
    "454": "Tyler Ulis",
    "455": "Jonas Valanciunas",
    "456": "Denzel Valentine",
    "457": "Jarred Vanderbilt",
    "458": "Fred VanVleet",
    "459": "Noah Vonleh",
    "460": "Nikola Vucevic",
    "461": "Dwyane Wade",
    "462": "Moritz Wagner",
    "463": "Dion Waiters",
    "464": "Lonnie Walker IV",
    "465": "Kemba Walker",
    "466": "Tyrone Wallace",
    "467": "John Wall",
    "468": "Brad Wanamaker",
    "469": "T.J. Warren",
    "470": "Yuta Watanabe",
    "471": "Thomas Welsh",
    "472": "Russell Westbrook",
    "473": "Derrick White",
    "474": "Hassan Whiteside",
    "475": "Andrew Wiggins",
    "476": "Robert Williams III",
    "477": "Alan Williams",
    "478": "C.J. Williams",
    "479": "Johnathan Williams",
    "480": "Kenrich Williams",
    "481": "Lou Williams",
    "482": "Marvin Williams",
    "483": "Troy Williams",
    "484": "D.J. Wilson",
    "485": "Justise Winslow",
    "486": "Christian Wood",
    "487": "Delon Wright",
    "488": "Guerschon Yabusele",
    "489": "Thaddeus Young",
    "490": "Trae Young",
    "491": "Cody Zeller",
    "492": "Ante Zizic",
    "493": "Ivica Zubac",
    "1364": "Joe Johnson",
    "1557": "Anderson Varejao",
    "1764": "Corey Brewer",
    "1771": "Joakim Noah",
    "1801": "Mario Chalmers",
    "1936": "Jeremy Pargo",
    "1980": "Jared Cunningham",
    "1983": "Tyler Zeller",
    "1988": "Donatas Motiejunas",
    "2048": "Anthony Bennett",
    "2075": "Devyn Marble",
    "2076": "Tarik Black",
    "2080": "JaKarr Sampson",
    "2099": "Bruno Caboclo",
    "2105": "CJ Wilcox",
    "2106": "Eric Moreland",
    "2117": "David Stockton",
    "2133": "Joe Young",
    "2148": "Thanasis Antetokounmpo",
    "2151": "Axel Toupane",
    "2158": "Patrick McCaw",
    "2160": "Isaiah Whitehead",
    "2164": "Semaj Christon",
    "2175": "Danuel House Jr.",
    "2178": "Jonathan Gibson",
    "2188": "Jarrod Uthoff",
    "2189": "Gary Payton II",
    "2190": "Isaiah Taylor",
    "2194": "Josh Magette",
    "2202": "Kobi Simmons",
    "2208": "Derrick Walton Jr.",
    "2211": "Antonius Cleveland",
    "2213": "London Perrantes",
    "2215": "Malcolm Miller",
    "2216": "Kadeem Allen",
    "2219": "Milton Doyle",
    "2222": "Myke Henry",
    "2223": "Ben Moore",
    "2225": "Josh Gray",
    "2226": "Erik McCree",
    "3089": "Gary Trent Jr.",
    "3090": "Jaron Blossomgame",
    "3091": "Brandon Goodwin",
    "3092": "Haywood Highsmith",
    "3450": "Deng Adel",
    "3943": "Julian Washburn",
    "5279": "Emanuel Terry",
    "5471": "Brandon Sampson",
    "45947": "Donte Grantham",
    "50609": "Dairis Bertans",
    "50661": "Chris Chiozza",
    "50729": "Michael Frazier",
    "50737": "Billy Garrett",
    "50793": "Isaac Humphries",
    "50815": "BJ Johnson",
    "50823": "Jemerrio Jones",
    "50927": "Kendrick Nunn",
    "50947": "Tarik Phillip",
    "50966": "Cameron Reynolds",
    "666393": "Jalen Adams",
    "666400": "Nickeil Alexander-Walker",
    "666401": "Kyle Alexander",
    "666423": "RJ Barrett",
    "666429": "Darius Bazley",
    "666438": "Javon Bess",
    "666440": "Kavell Bigby-Williams",
    "666442": "Goga Bitadze",
    "666446": "Keljin Blevins",
    "666451": "Bol Bol",
    "666453": "Marques Bolden",
    "666454": "Jordan Bone",
    "666457": "Phil Booth",
    "666459": "Brian Bowen II",
    "666460": "Ky Bowman",
    "666463": "Jarrell Brantley",
    "666464": "Ignas Brazdeikis",
    "666467": "Amida Brimah",
    "666468": "Oshae Brissett",
    "666474": "Charles Brown",
    "666476": "Moses Brown",
    "666486": "Devontae Cacok",
    "666488": "Perrion Callandret",
    "666489": "Vlatko Cancar",
    "666502": "Zylan Cheatham",
    "666505": "Brandon Clarke",
    "666508": "Nicolas Claxton",
    "666509": "Chris Clemons",
    "666511": "Amir Coffey",
    "666517": "Tyler Cook",
    "666523": "Jarrett Culver",
    "666529": "Jon Davis",
    "666530": "Terence Davis",
    "666541": "Luguentz Dort",
    "666543": "Sekou Doumbouya",
    "666551": "Carsen Edwards",
    "666552": "John Egbunu",
    "666560": "Tacko Fall",
    "666564": "Bruno Fernando",
    "666570": "Robert Franks",
    "666576": "Abdul Gaddy",
    "666577": "Daniel Gafford",
    "666580": "JaKeenan Gant",
    "666581": "Darius Garland",
    "666584": "Kaiser Gates",
    "666598": "Hassani Gravett",
    "666604": "Javonte Green",
    "666607": "Marko Guduric",
    "666608": "Kyle Guy",
    "666609": "Rui Hachimura",
    "666610": "Devon Hall",
    "666611": "Donta Hall",
    "666616": "Jared Harper",
    "666626": "Jaxson Hayes",
    "666630": "Dewan Hernandez",
    "666633": "Tyler Herro",
    "666637": "Ahmed Hill",
    "666640": "Amir Hinton",
    "666641": "Jaylen Hoard",
    "666647": "Daulton Hommes",
    "666650": "Talen Horton-Tucker",
    "666653": "William Howard",
    "666656": "De'Andre Hunter",
    "666672": "Justin James",
    "666675": "DaQuan Jeffries",
    "666676": "Ty Jerome",
    "666679": "Cameron Johnson",
    "666682": "Keldon Johnson",
    "666692": "Mfiondu Kabengele",
    "666697": "Stanton Kidd",
    "666698": "Louis King",
    "666702": "Sagaba Konate",
    "666703": "John Konchar",
    "666707": "Christ Koumadje",
    "666708": "David Kramer",
    "666713": "Romeo Langford",
    "666714": "Terry Larrier",
    "666716": "Dedric Lawson",
    "666717": "Vic Law",
    "666720": "Jalen Lecque",
    "666726": "Mathias Lessort",
    "666729": "Nassir Little",
    "666743": "Terance Mann",
    "666747": "Caleb Martin",
    "666748": "Cody Martin",
    "666750": "Jeremiah Martin",
    "666751": "Kelan Martin",
    "666754": "Garrison Mathews",
    "666755": "Dakota Mathias",
    "666757": "Luke Maye",
    "666758": "Tahjere McCall",
    "666762": "Jalen McDaniels",
    "666767": "Jordan McLaughlin",
    "666770": "Nicolo Melli",
    "666775": "Isaiah Miles",
    "666783": "Adam Mokoka",
    "666786": "Ja Morant",
    "666788": "Juwan Morgan",
    "666794": "Mychal Mulder",
    "666795": "Jordan Murphy",
    "666808": "Zach Norvell Jr.",
    "666809": "Jaylen Nowell",
    "666818": "Chuma Okeke",
    "666821": "KZ Okpala",
    "666824": "Miye Oni",
    "666827": "Tariq Owens",
    "666828": "James Palmer Jr.",
    "666831": "Eric Paschall",
    "666837": "Norvel Pelle",
    "666838": "Josh Perkins",
    "666840": "Lamar Peters",
    "666841": "Isaiah Pineiro",
    "666846": "Vincent Poirier",
    "666847": "Shamorie Ponds",
    "666848": "Jordan Poole",
    "666849": "Kevin Porter Jr.",
    "666859": "Josh Reaves",
    "666860": "Cameron Reddish",
    "666871": "Justin Robinson",
    "666873": "Isaiah Roby",
    "666881": "Luka Samanic",
    "666885": "Admiral Schofield",
    "666891": "Marial Shayok",
    "666892": "Simisola Shittu",
    "666894": "Chris Silva",
    "666897": "Justin Simon",
    "666899": "Deividas Sirvydis",
    "666900": "Alen Smailagic",
    "666908": "Max Strus",
    "666919": "Matt Thomas",
    "666923": "Matisse Thybulle",
    "666925": "Juan Toscano-Anderson",
    "666930": "Rayjon Tucker",
    "666940": "Dean Wade",
    "666950": "P.J. Washington",
    "666952": "Tremont Waters",
    "666953": "Quinndary Weatherspoon",
    "666956": "Coby White",
    "666960": "Lindell Wigginton",
    "666963": "Nigel Williams-Goss",
    "666965": "Grant Williams",
    "666969": "Zion Williamson",
    "666971": "Dylan Windler",
    "666973": "Todd Withers",
    "666975": "Kenny Wooten",
    "666976": "Justin Wright-Foreman",
    "667302": "Nicolo Melli",
    "667378": "Naz Reid",
    "1280857": "Kevin Hervey",
    "1358055": "Anzejs Pasecniks",
    "1567838": "Paul Watson",
    "1573276": "Levi Randolph",
    "1603383": "Gabe Vincent",
    "1687493": "Matt Mooney",
    "1891701": "Eric Mika",
    "1986689": "Malik Newman",
    "2116373": "Dusty Hannahs",
    "2270852": "Sir'Dominic Pointer",
    "2309958": "Jontay Porter",
    "3546977": "Greg Whittington",
    "3547095": "Udoka Azubuike",
    "3547163": "Mamadi Diakite",
    "3547164": "CJ Elleby",
    "3547169": "Reggie Perry",
    "3547197": "Devon Dotson",
    "3547207": "Jordan Nwora",
    "3547215": "Killian Tillie",
    "3547238": "Anthony Edwards",
    "3547239": "LaMelo Ball",
    "3547240": "James Wiseman",
    "3547241": "Killian Hayes",
    "3547242": "Deni Avdija",
    "3547243": "Obi Toppin",
    "3547244": "Onyeka Okongwu",
    "3547245": "Tyrese Haliburton",
    "3547246": "Devin Vassell",
    "3547247": "Isaac Okoro",
    "3547248": "Patrick Williams",
    "3547249": "Precious Achiuwa",
    "3547250": "Aaron Nesmith",
    "3547251": "Cole Anthony",
    "3547252": "Vernon Carey Jr.",
    "3547253": "Theo Maledon",
    "3547254": "Tyrese Maxey",
    "3547255": "Tyrell Terry",
    "3547256": "Saddiq Bey",
    "3547257": "R.J. Hampton",
    "3547258": "Josh Green",
    "3547259": "Jaden McDaniels",
    "3547260": "Kira Lewis Jr.",
    "3547261": "Nico Mannion",
    "3547262": "Jahmi'us Ramsey",
    "3547263": "Daniel Oturu",
    "3547264": "Jalen Smith",
    "3547265": "Tyler Bey",
    "3547266": "Elijah Hughes",
    "3547267": "Isaiah Stewart",
    "3547268": "Zeke Nnaji",
    "3547269": "Immanuel Quickley",
    "3547270": "Paul Reed",
    "3547271": "Aleksej Pokusevski",
    "3547272": "Isaiah Joe",
    "3547273": "Cassius Stanley",
    "3547274": "Tre Jones",
    "3547275": "Malachi Flynn",
    "3547276": "Payton Pritchard",
    "3547277": "Grant Riller",
    "3547278": "Ashton Hagans",
    "3547279": "Lamar Stevens",
    "3547280": "Jay Scrubb",
    "3547281": "Nate Hinton",
    "3547282": "Nick Richards",
    "3547283": "Markus Howard",
    "3547284": "Karim Mane",
    "3547285": "Xavier Tillman",
    "3547286": "Cassius Winston",
    "3547287": "Desmond Bane",
    "3547288": "Robert Woodard II",
    "3547289": "Skylar Mays",
    "3547290": "Josh Hall",
    "3547291": "Mason Jones",
    "3547292": "Jalen Harris",
    "3547293": "Naji Marshall",
    "3547294": "Kenyon Martin Jr.",
    "3547295": "Nathan Knight",
    "3547296": "Ty-Shon Alexander",
    "3547297": "Trent Forrest",
    "3547298": "Saben Lee",
    "3547299": "Sam Merrill",
    "3547300": "Sean McDermott",
    "3547301": "Jae'Sean Tate",
    "3547302": "Anthony Gill",
    "3547303": "Will Magnay",
    "3547304": "Facundo Campazzo",
    "3547305": "Nate Darling",
    "3547306": "Brodric Thomas",
    "4196798": "Doron Sheffer",
    "4196799": "Andrei Fetisov",
    "4196800": "Rashard Griffith",
    "4196801": "Aurelijius Zukauskas",
    "4196802": "Abdul Shamsid-Deen",
    "4196803": "Augusto Binelli",
    "4196804": "Ron Ellis",
    "4196805": "Marcelo Nicola",
    "4196806": "Alain Digbeau",
    "4196807": "Ben Pepper",
    "4196808": "Roberto Duenas",
    "4196809": "George Banks",
    "4196810": "Andrew Betts",
    "4196811": "Venson Hamilton",
    "4196812": "DeeAndre Hulett",
    "4196813": "Josip Sesar",
    "4196814": "Robertas Javtokas",
    "4196815": "Federico Kammerichs",
    "4196816": "Mladen Sekularac",
    "4196817": "Milos Vujanic",
    "4196818": "Peter Fehse",
    "4196821": "Sofoklis Schortsanitis",
    "4196822": "Szymon Szewczyk",
    "4196823": "Mario Austin",
    "4196824": "Sani Becirovic",
    "4196825": "Paccelis Morlende",
    "4196826": "Remon Van de Hare",
    "4196827": "Nedzad Sinanovic",
    "4196828": "Xue Yuyang",
    "4196832": "Albert Miralles",
    "4196833": "Viktor Sanikidze",
    "4196835": "Sergei Lishouk",
    "4196836": "Christian Drejer",
    "4196837": "Sergei Karaulov",
    "4196839": "Fran Vazquez",
    "4196841": "Erazem Lorbek",
    "4196842": "Axel Hervelle",
    "4196843": "Cenk Akyol",
    "4196850": "Lior Eliyahu",
    "4196852": "Vladimir Veremeenko",
    "4196853": "Yotam Halperin",
    "4196854": "Ejike Ugboaja",
    "4196855": "Edin Bavcic",
    "4196862": "Petteri Koponen",
    "4196863": "Stanko Barac",
    "4196865": "Renaldas Seibutis",
    "4196866": "Brad Newley",
    "4196867": "Giorgos Printezis",
    "4196868": "Milovan Rakovic",
    "4196882": "Ante Tomic",
    "4196884": "DeVon Hardin",
    "4196885": "Tadija Dragicevic",
    "4196886": "Maarty Leunen",
    "4196897": "Sergio Llull",
    "4196900": "Sergiy Gladyr",
    "4196902": "Emir Preldzic",
    "4196903": "Chinemelu Elonu",
    "4196904": "Henk Norel",
    "4196907": "Latavious Williams",
    "4196920": "Paulao Prestes",
    "4196921": "Dwayne Collins",
    "4196923": "Chukwudiebere Maduabum",
    "4196942": "MIlan Macvan",
    "4196944": "Adam Hanga",
    "4196945": "Jon Diebler",
    "4196965": "Izzet Turkyilmaz",
    "4196966": "Ilkan Karaman",
    "4196997": "Alex Oriakhi",
    "4196998": "Bojan Dubljevic",
    "4196999": "Janis Timma",
    "4197029": "Vasilije Micic",
    "4197032": "Nemanja Dangubic",
    "4197033": "Louis Labeyrie",
    "4197065": "Aaron White",
    "4197066": "Cady Lalanne",
    "4197068": "Nikola Milutinov",
    "4197069": "Arturas Gudaitis",
    "4197071": "Juan Pablo Vaulet",
    "4197072": "Marcus Eriksson",
    "4197073": "Tyler Harvey",
    "4197074": "Satnam Singh",
    "4197075": "Daniel Diez",
    "4197076": "Nikola Radicevic",
    "4197077": "Dimitrios Agravanis",
    "4197078": "Luka Mitrovic",
    "4197105": "Petr Cornelie",
    "4197110": "Isaia Cordinier",
    "4197111": "David Michineau",
    "4197112": "Wang Zhelin",
    "4197162": "Aleksandar Vezenkov",
    "4197165": "Ognen Jaramaz",
    "4197166": "Alpha Kaba",
    "4197192": "Jaylen Hands",
    "4197197": "Justin Jackson",
    "4197230": "Issuf Sanon",
    "4197231": "Vanja Marinkovic",
    "4197232": "Arnoldas Kulboka",
    "4197307": "Marcos Louzada Silva",
    "4197356": "Leandro Bolmaro",
    "4197384": "Yam Madar",
    "4197387": "Vit Krejci",
    "4197388": "Marko Simonovic",
    "4197389": "Justinian Jessup",
    "7155648": "Anthony Lamb",
    "9051997": "Armoni Brooks",
    "9177971": "Devin Cannady",
    "9318184": "Freddie Gillespie",
    "9338307": "Malik Fitts",
    "9530711": "Gabriel Deck",
    "10384980": "Myles Powell",
    "11314392": "Luca Vildoza",
    "11558583": "Cameron Oliver",
    "11755528": "Elijah Bryant",
    "11891374": "Omer Yurtseven",
    "12044014": "Caleb Homesley",
    "17553938": "Jordan Floyd",
    "17553939": "Alan Griffin",
    "17553940": "Tyson Carter",
    "17553941": "Micah Potter",
    "17553942": "Dru Smith",
    "17553943": "Alex Antetokounmpo",
    "17553944": "Matt Coleman",
    "17553945": "Damien Jefferson",
    "17553946": "Nick Mayo",
    "17553947": "Derrick Alston",
    "17553948": "Travis Munnings",
    "17553949": "Tim Williams",
    "17553954": "Sedrick Barefield",
    "17553957": "Scottie Lindsey",
    "17553967": "Neemias Queta",
    "17553968": "Joshua Obiesie",
    "17553971": "Marcus Graves",
    "17553972": "Ryan Taylor",
    "17553973": "Kendall Smith",
    "17553977": "Yoeli Childs",
    "17553979": "Jonathan Kuminga",
    "17553980": "Princepal Singh",
    "17553981": "Kahlil Whitney",
    "17553982": "Tres Tinkle",
    "17553983": "Trevelin Queen",
    "17553985": "Romaro Gill",
    "17553986": "Ade Murkey",
    "17553987": "Zavier Simpson",
    "17553988": "Jeff Dowtin",
    "17553989": "Elijah Pemberton",
    "17553990": "Isaiah Brown",
    "17553991": "Selom Mawugbe",
    "17553992": "Moses Moody",
    "17553993": "Joel Ayayi",
    "17553994": "Davion Mitchell",
    "17553995": "Austin Reaves",
    "17553996": "DJ Steward",
    "17553997": "Marcus Garrett",
    "17553998": "D.J. Stewart Jr.",
    "17553999": "Chaundee Brown",
    "17554000": "JaQuori McLaughlin",
    "17554001": "Javonte Smart",
    "17554002": "DeJon Jarreau",
    "17554003": "RJ Nembhard Jr.",
    "17554004": "AJ Lawson",
    "17554005": "Mac McClung",
    "17554006": "Jordan Schakel",
    "17554007": "Colbey Ross",
    "17554008": "Justin Smith",
    "17620634": "Brandon McCoy",
    "17895693": "Justin Turner",
    "17895694": "Biram Faye",
    "17895695": "Eric Demers",
    "17895696": "Tahj Eaddy",
    "17895697": "Asbjorn Midtgaard",
    "17895698": "Jeremiah Tilmon",
    "17895701": "D.J. Funderburk",
    "17895702": "Olivier Sarr",
    "17895703": "Keaton Wallace",
    "17895706": "Denzel Mahoney",
    "17895707": "Cameron McGriff",
    "17895708": "Sehmus Hazer",
    "17895709": "Tre Scott",
    "17895710": "Chandler Vaudrin",
    "17895711": "Caleb Agada",
    "17895712": "Giorgi Bezhanishvili",
    "17895713": "Chudier Bile",
    "17895714": "Jason Burnell",
    "17895715": "Steffon Mitchell",
    "17895716": "Arnas Velicka",
    "17895717": "LJ Figueroa",
    "17895718": "Mark Vital",
    "17895719": "Sterling Manley",
    "17895720": "Troy Baxter Jr.",
    "17895721": "Juwan Durham",
    "17895722": "Max Heidegger",
    "17895723": "Justin Jaworski",
    "17895724": "Ibi Watson",
    "17895725": "Jaime Echenique",
    "17895726": "Jordan Goodwin",
    "17895727": "Austin Hollins",
    "17895728": "Kyree Walker",
    "17895729": "James Banks III",
    "17895730": "Anas Mahmoud",
    "17895731": "Isiaha Mike",
    "17895732": "K.J. Lawson",
    "17895733": "Blake Francis",
    "17895734": "Spencer Littleson",
    "17895735": "Jamorko Pickett",
    "17895736": "Anthony Tarke",
    "17895737": "Lydell Elmore",
    "17895738": "David DiLeo",
    "17895739": "Malcolm Hill",
    "17895740": "Alpha Diallo",
    "17895741": "Jon Axel Gudmundsson",
    "17895742": "Trey Kell",
    "17895743": "Jo Lual-Acuil Jr.",
    "17895744": "Emmanuel Nzekwesi",
    "17895745": "Jaleen Smith",
    "17895746": "Justin Robinson",
    "17895747": "Marcus Foster",
    "17895748": "Jalen Tate",
    "17895749": "Tyler Hagedorn",
    "17895750": "Steven Enoch",
    "17895751": "John Mooney",
    "17895752": "Mike Smith",
    "17895753": "DMitrik Trice",
    "17895754": "Tyree White",
    "17895758": "Kyle Fogg",
    "17895762": "Deonte Burton",
    "17895769": "Keifer Sykes",
    "17895775": "Zach Auguste",
    "17895777": "Trey Davis",
    "17895791": "Terry Henderson",
    "17895793": "Cullen Russo",
    "17895796": "Vitto Brown",
    "17895798": "Jared Brownridge",
    "17895815": "Quinton Rose",
    "17895818": "Matur Maker",
    "17895819": "LiAngelo Ball",
    "17895821": "D.J. Hogg",
    "17895834": "Nate Mason",
    "17895835": "Bennie Boatwright",
    "17895838": "Aubrey Dawkins",
    "17895839": "Javin DeLaurier",
    "17895854": "Charles Bassey",
    "17895858": "Quentin Grimes",
    "17895865": "Charles Matthews",
    "17895875": "Aric Holman",
    "17895876": "Kaleb Wesson",
    "17895877": "Kerwin Roach",
    "17895878": "Zach Hankins",
    "17895899": "Shaq Buchanan",
    "17895902": "Tyler Hall",
    "17895903": "Brandon Randolph",
    "17895906": "Trey Phills",
    "17895907": "Stephen Domingo",
    "17895908": "Paul White",
    "17895910": "Kenny Williams",
    "17895911": "Barry Brown",
    "17895912": "Ahmad Caver",
    "17895913": "Kaleb Johnson",
    "17895914": "Matt Morgan",
    "17895941": "Filip Petrusev",
    "17895956": "Tyrique Jones",
    "17895963": "Paul Eboua",
    "17895966": "Jalen Green",
    "17895967": "Isaiah Todd",
    "17895968": "Daishen Nix",
    "17895983": "Ayo Dosunmu",
    "17895984": "Derrick Alston Jr.",
    "17895988": "Jon Teske",
    "17895990": "Jordan Ford",
    "17895991": "Jahlil Tripp",
    "17895992": "Rayshaun Hammonds",
    "17895994": "Xavier Sneed",
    "17895996": "E.J. Montgomery",
    "17895998": "Devonte Patterson",
    "17895999": "Jordan Bowden",
    "17896000": "Nathan Sestina",
    "17896005": "Emmitt Williams",
    "17896006": "Anthony Cowan Jr.",
    "17896007": "Braxton Key",
    "17896008": "Shakur Juiston",
    "17896009": "Rob Edwards",
    "17896010": "Darnell Cowart",
    "17896011": "Nate Renfro",
    "17896013": "Ryan Woolridge",
    "17896014": "Eugene German",
    "17896015": "JJ Culver",
    "17896016": "Jaire Grayer",
    "17896017": "Matt Ryan",
    "17896019": "Nahziah Carter",
    "17896020": "David Johnson",
    "17896021": "Jeremiah Robinson-Earl",
    "17896022": "Brandon Boston Jr.",
    "17896023": "Josh Christopher",
    "17896024": "Herbert Jones",
    "17896025": "Jaden Springer",
    "17896026": "Franz Wagner",
    "17896027": "Ziaire Williams",
    "17896028": "Greg Brown III",
    "17896029": "Sharife Cooper",
    "17896030": "Chris Duarte",
    "17896031": "Nah'Shon Hyland",
    "17896032": "Kai Jones",
    "17896033": "Miles McBride",
    "17896035": "Isaiah Jackson",
    "17896036": "Tre Mann",
    "17896037": "James Bouknight",
    "17896038": "Day'Ron Sharpe",
    "17896039": "Justin Champagnie",
    "17896040": "Jalen Johnson",
    "17896041": "Keon Johnson",
    "17896042": "Jason Preston",
    "17896044": "Kessler Edwards",
    "17896045": "Corey Kispert",
    "17896048": "Cam Thomas",
    "17896049": "David Duke Jr.",
    "17896050": "Matt Hurt",
    "17896051": "Joshua Primo",
    "17896052": "RaiQuan Gray",
    "17896053": "Aaron Henry",
    "17896054": "John Petty Jr.",
    "17896055": "Scottie Barnes",
    "17896056": "Luka Garza",
    "17896058": "Trendon Watford",
    "17896059": "Sandro Mamukelashvili",
    "17896060": "Sam Hauser",
    "17896061": "Scottie Lewis",
    "17896062": "Alperen Sengun",
    "17896063": "Jericho Sims",
    "17896064": "Joe Wieskamp",
    "17896065": "Josh Giddey",
    "17896066": "Yves Pons",
    "17896067": "Santi Aldama",
    "17896068": "Juhann Begarin",
    "17896070": "Usman Garuba",
    "17896071": "Isaiah Livers",
    "17896072": "Moses Wright",
    "17896073": "Jalen Suggs",
    "17896074": "McKinley Wright IV",
    "17896075": "Cade Cunningham",
    "17896076": "Evan Mobley",
    "17896078": "Aaron Wiggins",
    "17896079": "Rokas Jokubaitis",
    "17896080": "EJ Onu",
    "17896082": "Aamir Simms",
    "17896085": "Chris Smith",
    "17896086": "Oscar da Silva",
    "17896089": "Duane Washington Jr.",
    "17896090": "MaCio Teague",
    "17896091": "D.J. Carton",
    "17896092": "Jalen Crutcher",
    "17896093": "Feron Hunt",
    "17896094": "Dalano Banton",
    "17896095": "Isaiah Miller",
    "17896096": "Matt Mitchell",
    "17896097": "Jose Alvarado",
    "17896098": "Zaccheus Darko-Kelly",
    "17896099": "Carlik Jones",
    "17896101": "MJ Walker",
    "17896102": "Mitch Ballock",
    "17896103": "Jay Huff",
    "17896105": "Matt Coleman III",
    "17896106": "Eugene Omoruyi",
    "17896108": "Romeo Weems",
    "17896109": "Ryan Daly",
    "17896110": "Matt Lewis",
    "17896111": "Brandon Rachal",
    "17896113": "Devontae Shuler",
    "17896115": "Amar Sylla",
    "17896116": "Terry Taylor",
    "17896117": "Ethan Thompson",
    "17896118": "Marcus Zegarowski",
    "17896119": "Reid Travis",
    "17896120": "Ish Wainright",
    "17896121": "Josh Gray",
    "17951082": "Trey Murphy",
    "17957861": "JT Thor",
    "18030330": "Kerry Blackshear Jr.",
    "18036823": "Balsa Koprivica",
    "18039569": "Xavier Rathan-Mayes",
    "18041884": "Asante Gist",
    "18042321": "Asante Gist",
    "18170939": "Georgios Kalaitzakis",
    "18170949": "Giorgos Kalaitzakis",
    "18677827": "Johnny Hamilton",
    "18677954": "Jared Butler",
    "18677986": "Trey Murphy III",
    "18678001": "JT Thor",
    "18678048": "Balsa Koprivica",
    "18678057": "Jamorko Pickett",
    "18678058": "Jordan Goodwin",
    "19465326": "Jock Landale",
    "19465583": "Jaime Echenique",
    "19465584": "Micah Potter",
    "19465585": "Dru Smith",
    "19465586": "Kevin Pangos",
    "23800531": "Aleem Ford",
    "24102469": "Malcolm Hill",
    "24338188": "Cat Barber",
    "24338541": "Malik Ellison",
    "24417679": "Xavier Moon",
    "24489019": "Jarron Cumberland",
    "24489167": "Brandon Williams",
    "24489241": "Cameron McGriff",
    "24572055": "Olivier Sarr",
    "24590029": "Craig Sword",
    "24590098": "Justin Tillman",
    "24602685": "Trayvon Palmer",
    "24839769": "Paris Bass",
    "24850479": "Jaysean Paige",
    "27924547": "Lindy Waters III",
    "30053472": "Gabriel Lundberg",
    "31890572": "Gabe York",
    "38017507": "Andrew Nembhard",
    "38017607": "Kevon Harris",
    "38017620": "Ochai Agbaji",
    "38017630": "Johnny Juzang",
    "38017649": "Julian Champagnie",
    "38017656": "Scotty Pippen Jr.",
    "38017662": "Isaiah Mobley",
    "38017663": "E.J. Liddell",
    "38017665": "Darius Days",
    "38017676": "MarJon Beauchamp",
    "38017677": "Dyson Daniels",
    "38017678": "Michael Foster Jr.",
    "38017679": "Jaden Hardy",
    "38017682": "Jaden Ivey",
    "38017683": "Paolo Banchero",
    "38017684": "Jabari Smith Jr.",
    "38017685": "Chet Holmgren",
    "38017686": "Bennedict Mathurin",
    "38017687": "Johnny Davis",
    "38017688": "Keegan Murray",
    "38017689": "AJ Griffin",
    "38017690": "Shaedon Sharpe",
    "38017691": "TyTy Washington Jr.",
    "38017692": "Malaki Branham",
    "38017693": "Blake Wesley",
    "38017694": "Jalen Duren",
    "38017695": "Tari Eason",
    "38017696": "Nikola Jovic",
    "38017697": "Max Christie",
    "38017698": "Mark Williams",
    "38017699": "Jeremy Sochan",
    "38017700": "Wendell Moore Jr.",
    "38017701": "Kendall Brown",
    "38017702": "Kennedy Chandler",
    "38017703": "Jalen Williams",
    "38017704": "Patrick Baldwin Jr.",
    "38017705": "Walker Kessler",
    "38017706": "Jaylin Williams",
    "38017707": "JD Davison",
    "38017708": "Bryce McGowens",
    "38017709": "Christian Braun",
    "38017710": "Christian Koloko",
    "38017711": "Jabari Walker",
    "38017712": "Ryan Rollins",
    "38017713": "Jordan Hall",
    "38017714": "Keon Ellis",
    "38017715": "Josh Minott",
    "38017716": "Ousmane Dieng",
    "38017717": "Ron Harper Jr.",
    "38017718": "Buddy Boeheim",
    "38017719": "Dalen Terry",
    "38017720": "Trevor Keels",
    "38017721": "Peyton Watson",
    "38017722": "Tyrese Martin",
    "38017723": "Alondes Williams",
    "38017724": "Caleb Houstan",
    "38017725": "Moussa Diabate",
    "38017726": "Dereon Seabron",
    "38017727": "Collin Gillespie",
    "38017728": "Jake LaRavia",
    "38017729": "David Roddy",
    "38017730": "Dominick Barlow",
    "38017731": "Vince Williams Jr.",
    "38017732": "Kenneth Lofton Jr.",
    "38017733": "A.J. Green",
    "38017734": "Jamal Cain",
    "38017735": "Jack White",
    "38017736": "Cole Swider",
    "38017737": "Trevor Hudgins",
    "38017738": "Chima Moneke",
    "38017739": "Simone Fontecchio",
    "38124126": "John Butler Jr.",
    "39398582": "Orlando Robinson",
    "39613724": "Ibou Badji",
    "42097199": "Jared Rhoden",
    "43516144": "Donovan Williams",
    "44477024": "Stanley Umude",
    "44477062": "Jamaree Bouyea",
    "44477085": "Quenton Jackson",
    "45088184": "Keaton Wallace",
    "45658838": "Lester Quinones",
    "45969255": "Justin Lewis",
    "46389569": "Jim Seminoff",
    "46389570": "Johnny Logan",
    "46389571": "George Munroe",
    "46389572": "Aubrey Davis",
    "46389573": "Doyle Parrack",
    "46389574": "Chuck Halbert",
    "46389575": "Max Zaslofsky",
    "46389576": "Don Putman",
    "46389577": "Herschel Baltimore",
    "46389578": "Chet Carlisle",
    "46389579": "Don Martin",
    "46389580": "Wilbert Kautz",
    "46389581": "Tony Jaros",
    "46389582": "Bob Doll",
    "46389583": "Giff Roux",
    "46389584": "Belus Smawley",
    "46389585": "Chuck Gilmur",
    "46389586": "Don Carlson",
    "46389587": "Cecil Hankins",
    "46389588": "Mickey Rottner",
    "46389589": "Ralph Kaplowitz",
    "46389590": "George Senesky",
    "46389591": "Audley Brindley",
    "46389592": "Jack Garfinkel",
    "46389593": "Bob Faught",
    "46389594": "Lee Knorek",
    "46389595": "Sidney Hertzberg",
    "46389596": "Johnny Simmons",
    "46389597": "Art Spector",
    "46389598": "Harold Kottman",
    "46389599": "Ray Wertis",
    "46389600": "Adolph Hoefer",
    "46389601": "Leo Gottlieb",
    "46389602": "Tommy Byrnes",
    "46389603": "Angelo Musi",
    "46389604": "Frido Frey",
    "46389605": "Mel Riebe",
    "46389606": "George Nostrand",
    "46389607": "Jerry Rullo",
    "46389608": "Matt Guokas",
    "46389609": "Nick Shaback",
    "46389610": "Gerard Kelly",
    "46389611": "Art Hillhouse",
    "46389612": "Ed Sadowski",
    "46389613": "Butch Van",
    "46389614": "Stan Stutz",
    "46389615": "Joe Fulks",
    "46389616": "John Palmer",
    "46389617": "Connie Simmons",
    "46389618": "Ben Scharnus",
    "46389619": "Marion Cluggish",
    "46389620": "Howie Dallmar",
    "46389621": "Al Brightman",
    "46389622": "Bob Fitzgerald",
    "46389623": "Jerry Fleishman",
    "46389624": "Alexander Rosenberg",
    "46389625": "Kenny Sailors",
    "46389626": "John Janisch",
    "46389627": "Bob Gantt",
    "46389628": "Ariel Maughan",
    "46389629": "Bob Dille",
    "46389630": "Dick Schulz",
    "46389631": "John Mahnken",
    "46389632": "Bob Mullens",
    "46389633": "Ernie Calverley",
    "46389634": "Hank Beenders",
    "46389635": "Irv Torgoff",
    "46389636": "Mike McCarron",
    "46389637": "Ralph Siewert",
    "46389638": "Freddie Scolari",
    "46389639": "Harry Miller",
    "46389640": "Harold Brown",
    "46389641": "Dick Fitzgerald",
    "46389642": "Stan Miasek",
    "46389643": "Bob Shea",
    "46389644": "Leo Mogus",
    "46389645": "George Mearns",
    "46389646": "Johnny Norlander",
    "46389647": "Bill Davis",
    "46389648": "Horace McKinney",
    "46389649": "Nat Militzok",
    "46389650": "Marty Passaglia",
    "46389651": "George Grimshaw",
    "46389652": "Art Stolkey",
    "46389653": "Ken Keller",
    "46389654": "Michael Wallace",
    "46389655": "Hank Rosenstein",
    "46389656": "Tom King",
    "46389657": "Grady Lewis",
    "46389658": "Donald Martin",
    "46389659": "Elmo Morgenthaler",
    "46389660": "Earl Shannon",
    "46389661": "Bob Feerick",
    "46389662": "Wilfred Goodwin",
    "46389663": "Moe Becker",
    "46389664": "Hank Lefkowitz",
    "46389665": "Milt Schoon",
    "46389666": "Hank Zeller",
    "46389667": "Coulby Gunther",
    "46389668": "Stan Noszka",
    "46389669": "Ed Melvin",
    "46389670": "Francis O'Grady",
    "46389671": "Wyndol Gray",
    "46389672": "Mike Bytzura",
    "46389673": "Tony Kappen",
    "46389674": "John Abramovic",
    "46389675": "John Barr",
    "46389676": "Roger Jorgensen",
    "46389677": "Deb Smith",
    "46389678": "Forest Weber",
    "46389679": "George A.",
    "46389680": "Ossie Schectman",
    "46389681": "Noble Jorgensen",
    "46389682": "Peter Maravich",
    "46389683": "Leon Brown",
    "46389684": "Howie McCarty",
    "46389685": "Chuck Connors",
    "46389686": "Roy Hurley",
    "46389687": "John Mills",
    "46389688": "Frankie Baumholtz",
    "46389689": "Dick Murphy",
    "46389690": "Bob Duffy",
    "46389691": "Johnny Jorgensen",
    "46389692": "Henry Pearcy",
    "46389693": "Joe Fabel",
    "46389694": "John Murphy",
    "46389695": "George Pearcy",
    "46389696": "Frank Mangiapane",
    "46389697": "Gene Gillette",
    "46389698": "Garland O'Shields",
    "46389699": "Clarence Hermsen",
    "46389700": "Virgil Vaughn",
    "46389701": "Chet Aubuchon",
    "46389702": "Irv Rothenberg",
    "46390197": "Harold Johnson",
    "46390198": "Armand Cure",
    "46390199": "Bill Fenley",
    "46390200": "Fred Sheffield",
    "46390201": "Ed Kasid",
    "46390202": "Frank Fucarino",
    "46390203": "Red Dehnert",
    "46390204": "Wallace Sydnor",
    "46390205": "Pete Lalich",
    "46390206": "Gorham Getchell",
    "46390207": "Gino Sovran",
    "46390208": "Hal Crisler",
    "46390209": "Winfred Jacobs",
    "46390210": "Ned Endress",
    "46390211": "Tom Callahan",
    "46390212": "Al Lujack",
    "46390213": "Mel Hirsch",
    "46390214": "Don Eliason",
    "46390215": "Walt Miller",
    "46390216": "Al Negratti",
    "46390217": "Hank Biasatti",
    "46390218": "Rob Rensberger",
    "46390219": "Nat Frankel",
    "46390220": "Lou Spicer",
    "46390221": "Norm Baker",
    "46390222": "Zigmund Mihalik",
    "46390223": "Ben Goldfaden",
    "46390224": "Buddy Jeannette",
    "46390225": "Bear, The",
    "46390226": "Paul Huston",
    "46390227": "Carl Meinhold",
    "46390228": "Andy Phillip",
    "46390229": "Ben Schadler",
    "46390230": "Joseph Reiser",
    "46390231": "Gene Vance",
    "46390232": "Jack Tingle",
    "46390233": "Dick O'Keefe",
    "46390234": "Red Rocha",
    "46390235": "Jack Toomay",
    "46390236": "Herm Klotz",
    "46390237": "Ray Kuka",
    "46390238": "Bob Hubbard",
    "46390239": "Johnny Ezersky",
    "46390240": "Paul Noel",
    "46390241": "Dick Holub",
    "46390242": "Herm Fuetsch",
    "46390243": "Gene Rock",
    "46390244": "Sid Tannenbaum",
    "46390245": "Carl Braun",
    "46390246": "Mel Thurston",
    "46390247": "Gene Stump",
    "46390248": "Saul Mariaschin",
    "46390249": "Mike Bloom",
    "46390250": "Francis Crossin",
    "46390251": "Bob O'Brien",
    "46390252": "Lee Robbins",
    "46390253": "Eddie Ehlers",
    "46390254": "Bill Downey",
    "46390255": "Paul Seymour",
    "46390256": "Matthew Hickey",
    "46390751": "Jack Hewson",
    "46390752": "Jack Rocker",
    "46390753": "Stan Brown",
    "46390754": "Elmer R.",
    "46390755": "Wat Misaka",
    "46390756": "Chet McNabb",
    "46390757": "Bob Davies",
    "46390758": "Kenny Rollins",
    "46390759": "Arnie Risen",
    "46390760": "Jim Pollard",
    "46390761": "Bill Calhoun",
    "46390762": "George Mikan",
    "46390763": "Ed Mikan",
    "46390764": "Paul Armstrong",
    "46390765": "Bobby Wanzer",
    "46390766": "Joe Graboski",
    "46390767": "Arnie Ferrin",
    "46390768": "Arnie Johnson",
    "46390769": "Red Holzman",
    "46390770": "Odie Spears",
    "46390771": "D.C. Wilcutt",
    "46390772": "Bill Roberts",
    "46390773": "Otto Schnellbacher",
    "46390774": "Leo Klier",
    "46390775": "Mike Novak",
    "46390776": "Charlie Black",
    "46390777": "Dick Triptow",
    "46390778": "Jake Bornheimer",
    "46390779": "Bill Henry",
    "46390780": "Bill Miller",
    "46390781": "Estes Parham",
    "46390782": "Ward Williams",
    "46390783": "Jack Dwan",
    "46390784": "Fran Curran",
    "46390785": "Andy Duncan",
    "46390786": "Donnie Forman",
    "46390787": "Gale Bishop",
    "46390788": "Bob Tough",
    "46390789": "John Niemiera",
    "46390790": "Herm Schaefer",
    "46390791": "Jack Smiley",
    "46390792": "Edwin Kachan",
    "46390793": "Walter Budko",
    "46390794": "Jack Nichols",
    "46390795": "Harry Gallatin",
    "46390796": "Ray Lumpp",
    "46390797": "Fred Lewis",
    "46390798": "Mel McGaha",
    "46390799": "Earl Gardner",
    "46390800": "Leo Katkaveck",
    "46390801": "Matt Zunic",
    "46390802": "Howard Tidrick",
    "46390803": "Gene James",
    "46390804": "George Kaftan",
    "46390805": "Goebel Ritter",
    "46390806": "Joe Colone",
    "46390807": "Phil Farbman",
    "46390808": "Dermie O'Connell",
    "46390809": "Bob Kinney",
    "46390810": "Brady Walker",
    "46390811": "Les Pugh",
    "46390812": "Bruce Hale",
    "46390813": "Jake Pelkington",
    "46390814": "Howie Shannon",
    "46390815": "Bob Brown",
    "46390816": "Lionel Malamed",
    "46390817": "Jack Eskridge",
    "46390818": "John Mandic",
    "46390819": "William Towery",
    "46390820": "Price Brookfield",
    "46390821": "Ralph Hamilton",
    "46390822": "Fred Nagy",
    "46390823": "Walt Kirk",
    "46390824": "Doug Holcomb",
    "46390825": "Andrew Levane",
    "46390826": "Jim Spruill",
    "46390827": "Tom Kelly",
    "46390828": "Jim Springer",
    "46390829": "Johnny Bach",
    "46391324": "Roy Pugh",
    "46391325": "Donald Smith",
    "46391326": "Ray Ramsey",
    "46391327": "Jack Maddox",
    "46391328": "Andy Kostecka",
    "46391329": "Jim Browne",
    "46391330": "Andy Tonkovich",
    "46391331": "Dan Kraus",
    "46391332": "John W.",
    "46391333": "Dick Wehr",
    "46391334": "Dillard Crocker",
    "46391335": "Howie Rader",
    "46391336": "Ray Ellefson",
    "46391337": "Herb Krautblatt",
    "46391338": "George Glamack",
    "46391339": "Lonnie Eggleston",
    "46391340": "Dick Shrider",
    "46391341": "Al Lucas",
    "46391342": "Darrell Brown",
    "46391343": "Fred Paine",
    "46391344": "Slater Martin",
    "46391345": "Vern Mikkelsen",
    "46391346": "Frank Saul",
    "46391347": "Jack Coleman",
    "46391348": "Bob Harrison",
    "46391349": "Howie Schultz",
    "46391350": "David Johnson",
    "46391351": "Duane Klueh",
    "46391352": "Jack Kerris",
    "46391353": "Clint Wager",
    "46391354": "Jerry Nagel",
    "46391355": "Frank Kudelka",
    "46391356": "Joe Bradley",
    "46391357": "Johnny Oldham",
    "46391358": "Fred Schaus",
    "46391359": "Bob Carpenter",
    "46391360": "Bob Harris",
    "46391361": "Leo Barnhorst",
    "46391362": "James Owens",
    "46391363": "John Hargis",
    "46391364": "Billy Gabor",
    "46391365": "Johnny Orr",
    "46391366": "Ed Stanczak",
    "46391367": "Leroy Chollet",
    "46391368": "Ed Peterson",
    "46391369": "Joe Dolhon",
    "46391370": "Jake Carter",
    "46391371": "Alex Hannum",
    "46391372": "Andy O'Donnell",
    "46391373": "Murray Wier",
    "46391374": "Dee Gibson",
    "46391375": "Don Ray",
    "46391376": "Mac Otten",
    "46391377": "Milo Komenich",
    "46391378": "Whitey Von",
    "46391379": "Leo Kubiak",
    "46391380": "Thomas Eddleman",
    "46391381": "Harry Boykoff",
    "46391382": "Frank Brian",
    "46391383": "Bill Closs",
    "46391384": "Dick Mehen",
    "46391385": "Johnny Payak",
    "46391386": "Bud Grant",
    "46391387": "Ray Corley",
    "46391388": "Don Boven",
    "46391389": "George Ratkovicz",
    "46391390": "Al Cervi",
    "46391391": "Ed Macauley",
    "46391392": "Frank Gates",
    "46391393": "Dolph Schayes",
    "46391394": "Wayne See",
    "46391395": "Marko Todorovich",
    "46391396": "Johnny Macknowski",
    "46391397": "Mal McMullan",
    "46391398": "Cliff Barker",
    "46391399": "Bob Evans",
    "46391400": "Carl Shaeffer",
    "46391401": "Harry Donovan",
    "46391402": "Ralph Beard",
    "46391403": "Jimmy Darden",
    "46391404": "Dick McGuire",
    "46391405": "Wallace Jones",
    "46391406": "Stan Patrick",
    "46391407": "Warren Perkins",
    "46391408": "Don Otten",
    "46391409": "Floyd Volker",
    "46391410": "Joe Holland",
    "46391411": "Bob Brannum",
    "46391412": "Jack Phelan",
    "46391413": "George Sobek",
    "46391414": "Vince Boryla",
    "46391415": "Jack Burmaster",
    "46391416": "Paul Walther",
    "46391417": "Jack Cotton",
    "46391418": "Alex Groza",
    "46391419": "Max Morris",
    "46391420": "Marshall Hawkins",
    "46391421": "Tony Lavelli",
    "46391422": "Ron Livingstone",
    "46391423": "Nelson Bobb",
    "46391424": "Al Guokas",
    "46391425": "Vern Gardner",
    "46391426": "Ed Leede",
    "46391427": "John Dillon",
    "46391428": "Joe Mullaney",
    "46391429": "Bobby Cook",
    "46391430": "Ed Bartels",
    "46391431": "Billy Hassett",
    "46391432": "Ernie Vandeweghe",
    "46391433": "Gene Englund",
    "46391434": "Bill Herman",
    "46391435": "Walt Lautenbach",
    "46391930": "Ken Menke",
    "46391931": "Ward Gibson",
    "46391932": "Bob Royer",
    "46391933": "Marv Schatzman",
    "46391934": "Rollie Seltz",
    "46391935": "Matt Mazza",
    "46391936": "John Chaney",
    "46391937": "Howie Janotta",
    "46391938": "George Feigenbaum",
    "46391939": "Charlie Shipp",
    "46391940": "Charlie Parsley",
    "46392435": "Bob Hahn",
    "46392436": "Glen Selbo",
    "46392437": "Paul Cloyd",
    "46392438": "Danny Wagner",
    "46392439": "Dale Hamilton",
    "46392440": "Gene Ollrich",
    "46392441": "Bob Wood",
    "46392442": "Al Miksis",
    "46392443": "Earl Dodd",
    "46392444": "John Pritchard",
    "46392445": "Jim Nolan",
    "46392446": "Jack Parkinson",
    "46392447": "Murray Mitchell",
    "46392448": "Paul Gordon",
    "46392449": "Don Grate",
    "46392450": "Gene Berce",
    "46392451": "Norman Glick",
    "46392452": "Cal Christensen",
    "46392453": "Bob Lavoy",
    "46392454": "Nat Clifton",
    "46392455": "Larry Foust",
    "46392456": "Bob Cousy",
    "46392457": "Chuck Cooper",
    "46392458": "Herb Scherer",
    "46392459": "Bob Donham",
    "46392460": "Joe Hutton",
    "46392461": "Ken Murray",
    "46392462": "Kevin O'Shea",
    "46392463": "Paul Arizin",
    "46392464": "Joe McNamee",
    "46392465": "Don Rehfeldt",
    "46392466": "Don Lofgran",
    "46392961": "Gerry Calabrese",
    "46392962": "Art Burris",
    "46392963": "Ed Beach",
    "46392964": "Jim Riffey",
    "46392965": "Norm Mager",
    "46392966": "Costic Borsavage",
    "46392967": "Dick Schnittker",
    "46392968": "Bill Sharman",
    "46392969": "Alan Sawyer",
    "46392970": "Chuck Mrazovich",
    "46392971": "Hank DeZonie",
    "46392972": "Ed Gayda",
    "46392973": "Tommy O'Keefe",
    "46392974": "Earl Lloyd",
    "46393469": "Leon Blevins",
    "46393470": "Don Barksdale",
    "46393471": "Lew Hitch",
    "46393472": "Charlie Share",
    "46393473": "George King",
    "46393474": "Bill Tosheff",
    "46393475": "Jake Fendley",
    "46393476": "Wally Osterkorn",
    "46393477": "Buckshot O'Brien",
    "46393478": "Al McGuire",
    "46393479": "Dick Dickey",
    "46393480": "Jim Slaughter",
    "46393481": "Jack Kiley",
    "46393482": "Neil Johnston",
    "46393483": "Mel Hutchins",
    "46393484": "Bob Wilson",
    "46393485": "Ray Ragelis",
    "46393486": "Nate DeLong",
    "46393487": "Mel Payton",
    "46393488": "Dave Minor",
    "46393489": "Whitey Skoog",
    "46393490": "John Rennicke",
    "46393491": "Sam Ranzino",
    "46393492": "Ed Dahler",
    "46393987": "John Pilch",
    "46393988": "Don Savage",
    "46393989": "John McConathy",
    "46393990": "Jerry Fowler",
    "46393991": "Elmer Behnke",
    "46393992": "Zeke Sinicola",
    "46393993": "Paul McConnell",
    "46393994": "Al Masino",
    "46393995": "Gene Rhodes",
    "46393996": "Robert Zawoluk",
    "46393997": "Jim Holstein",
    "46393998": "Don Meineke",
    "46393999": "Don Henriksen",
    "46394000": "Dick Bunt",
    "46394001": "Eddie Miller",
    "46394002": "Jim Baechtold",
    "46394003": "Francis Mahoney",
    "46394004": "Bob Priddy",
    "46394005": "Dick Surhoff",
    "46394006": "Bob Lochmueller",
    "46394007": "Sherwin Raiken",
    "46394008": "Danny Finn",
    "46394009": "Jim Mooney",
    "46394010": "Mark Workman",
    "46394011": "Jack McMahon",
    "46394012": "Ralph Polson",
    "46394013": "Bill Mlkvy",
    "46394014": "Gene Conley",
    "46394015": "Dick Groat",
    "46394016": "George McLeod",
    "46394017": "Jack McCloskey",
    "46394018": "Mike O'Neill",
    "46394513": "Jim Brasco",
    "46394514": "Blaine Denning",
    "46394515": "Don Hanrahan",
    "46394516": "Claude Overton",
    "46394517": "Henry Darcey",
    "46394518": "Bob Naber",
    "46394519": "John O'Boyle",
    "46394520": "Moe Radovich",
    "46394521": "Walt Davis",
    "46394522": "Ernie Barrett",
    "46394523": "Rollen Hans",
    "46394524": "Norm Swanson",
    "46394525": "Bill Kenville",
    "46394526": "Bob Houbregs",
    "46394527": "Al Roges",
    "46394528": "George Yardley",
    "46394529": "Donald Ackerman",
    "46394530": "Jim Fritsche",
    "46394531": "Joe Smyth",
    "46394532": "Jim Luisi",
    "46394533": "Jim Neal",
    "46394534": "Irv Bemoras",
    "46394535": "Ray Felix",
    "46394536": "Connie Rea",
    "46394537": "Jack George",
    "46394538": "Clyde Lovellette",
    "46394539": "Don Sunderlage",
    "46394540": "Ed Smith",
    "46395035": "Jack Molinas",
    "46395036": "Don Asmonga",
    "46395037": "Gene Dyker",
    "46395038": "Bill Bolger",
    "46395039": "Hal Uplinger",
    "46395040": "Bato Govedarica",
    "46395041": "Ernie Beck",
    "46395042": "Frank Reddout",
    "46395043": "Bob Peterson",
    "46395044": "Jim Phelan",
    "46395045": "Rabbit Walthour",
    "46395046": "Dick Knostman",
    "46395047": "Paul Nolen",
    "46395048": "Ed Earle",
    "46395049": "Norm Grekin",
    "46395050": "Jackie Moore",
    "46395051": "Frank Selvy",
    "46395052": "Bob Pettit",
    "46395053": "George Dempsey",
    "46395054": "Bobby Watson",
    "46395055": "Jim Tucker",
    "46395056": "Dick Farley",
    "46395057": "Bert Cook",
    "46395058": "Frank Ramsey",
    "46395059": "Johnny Kerr",
    "46395060": "Gene Shue",
    "46395061": "Dwight Morrison",
    "46395062": "Jack Turner",
    "46395063": "Togo Palazzi",
    "46395064": "Dick Rosenthal",
    "46395065": "Art Spoelstra",
    "46395066": "Bob Carney",
    "46395067": "Ed Kalafat",
    "46395068": "Tom Marshall",
    "46395069": "Michael Kearns",
    "46395070": "Carl McNulty",
    "46395565": "Lucian Whitaker",
    "46395566": "Herm Hedderick",
    "46395567": "Tom Brennan",
    "46395568": "Larry Costello",
    "46395569": "Fred Diute",
    "46395570": "Ronnie MacGilvray",
    "46395571": "Chuck Grigsby",
    "46395572": "Ken McBride",
    "46395573": "Bob Knight",
    "46395574": "Fred Christ",
    "46395575": "Boris Nachamkin",
    "46395576": "Phil Martin",
    "46395577": "Don Anielak",
    "46395578": "Chuck Mencel",
    "46395579": "Bob Schafer",
    "46395580": "Dick Garmaker",
    "46395581": "Medford Park",
    "46395582": "Jack Stephens",
    "46395583": "Al Ferrari",
    "46395584": "Ed Conlin",
    "46395585": "Ken Sears",
    "46395586": "Larry Hennessy",
    "46395587": "Walter Devlin",
    "46395588": "Chuck Noble",
    "46395589": "Jim Loscutoff",
    "46395590": "Tom Gola",
    "46395591": "Dick Hemric",
    "46395592": "Walter Dukes",
    "46395593": "Ed Fleming",
    "46395594": "Dick Ricketts",
    "46395595": "Chris Harris",
    "46395596": "Maurice Stokes",
    "46395597": "Richie Regan",
    "46395598": "Jack Twyman",
    "46396093": "Jesse Arnelle",
    "46396094": "Richard Atha",
    "46396095": "Johnny Horan",
    "46396096": "James Davis",
    "46396097": "Bob Williams",
    "46396098": "Ron Feiereisel",
    "46396099": "Don Bielke",
    "46396100": "Bob Santini",
    "46396101": "Cliff Hagan",
    "46396102": "Jim Paxson",
    "46396103": "Bob Leonard",
    "46396104": "Bill Thieben",
    "46396105": "Dave Piontek",
    "46396106": "Bob Hopkins",
    "46396107": "Johnny McCarthy",
    "46396108": "Joe Holup",
    "46396109": "Al Bianchi",
    "46396110": "Bill Russell",
    "46396111": "Willie Naulls",
    "46396112": "Bob Burrow",
    "46396113": "Ron Sobie",
    "46396114": "Richie Guerin",
    "46396115": "Tom Heinsohn",
    "46396610": "John Barber",
    "46396611": "Lou Tsioropoulos",
    "46396612": "Phil Jordon",
    "46396613": "Bob Armstrong",
    "46396614": "Ron Shavlik",
    "46396615": "Norm Stewart",
    "46396616": "Si Green",
    "46396617": "Gary Bergen",
    "46396618": "Jim Ray",
    "46396619": "Hal Lear",
    "46396620": "Forest Able",
    "46397115": "Pat Dunn",
    "46397116": "Sam Jones",
    "46397117": "Woody Sauldsberry",
    "46397118": "Guy Sparrow",
    "46397119": "Larry Friend",
    "46397120": "Jim Krebs",
    "46397121": "Rod Hundley",
    "46397122": "Charlie Tyra",
    "46397123": "Brendan McCann",
    "46397124": "Lennie Rosenbluth",
    "46397125": "Bo Erias",
    "46397126": "Win Wilfong",
    "46397127": "Joel Ingram",
    "46397128": "Dick Duckett",
    "46397129": "Jim Walsh",
    "46397130": "Bill Ebben",
    "46397131": "Jerry Paulson",
    "46397132": "Doug Bolstorff",
    "46397133": "Worthy Patterson",
    "46397134": "George Brown",
    "46397629": "Ray Radziszewski",
    "46397630": "Hal Greer",
    "46397631": "Hub Reed",
    "46397632": "Elgin Baylor",
    "46397633": "Connie Dierking",
    "46397634": "Alexander Ellis",
    "46397635": "Steve Hamilton",
    "46397636": "Shellie McMillon",
    "46397637": "Arlen Bockhorn",
    "46397638": "K.C. Jones",
    "46397639": "Mike Farmer",
    "46397640": "Wayne Embry",
    "46397641": "Bennie Swain",
    "46397642": "Pete Brennan",
    "46397643": "Guy Rodgers",
    "46397644": "Jim Palmer",
    "46397645": "Archie Dees",
    "46397646": "Andy Johnson",
    "46397647": "Vern Hatton",
    "46397648": "Jack Parr",
    "46397649": "Larry Staverman",
    "46397650": "Barney Cable",
    "46397651": "Phil Rollins",
    "46397652": "Jerry Bird",
    "46398147": "Dave Gambee",
    "46398148": "Tommy Kearns",
    "46398149": "Johnny Green",
    "46398150": "Rudy LaRusso",
    "46398151": "Tom Hawkins",
    "46398152": "William Bell",
    "46398153": "Bailey Howell",
    "46398154": "Bob Ferry",
    "46398155": "Wilt Chamberlain",
    "46398156": "Gene Guarilia",
    "46398157": "John Richter",
    "46398158": "Dick Barnett",
    "46398159": "Gary Alcorn",
    "46398160": "Tony Windis",
    "46398161": "Joe Ruklick",
    "46398162": "Nick Mantis",
    "46398163": "Bob Anderegg",
    "46398658": "Cal Ramsey",
    "46398659": "Wayne Stevens",
    "46398660": "Bobby Smith",
    "46398661": "Maury King",
    "46398662": "Jerry West",
    "46398663": "George Lee",
    "46398664": "Harvey Halbrook",
    "46398665": "Bob Boozer",
    "46398666": "Darrall Imhoff",
    "46398667": "Bob McNeill",
    "46398668": "Thomas Sanders",
    "46398669": "Dave Budd",
    "46398670": "Oscar Robertson",
    "46398671": "Joe Roberts",
    "46398672": "Don Ohl",
    "46398673": "Howie Jolliff",
    "46398674": "Ralph Davis",
    "46398675": "Fred LaCour",
    "46398676": "Alvin Attles",
    "46398677": "Willie Jones",
    "46398678": "Lenny Wilkens",
    "46398679": "Jackie Moreland",
    "46398680": "Ron Johnson",
    "46398681": "William Kennedy",
    "46399176": "Frank Radovich",
    "46399177": "Lee Shaffer",
    "46399178": "Bob Sims",
    "46399179": "Horace Walker",
    "46399180": "Ted Luckenbill",
    "46399181": "York Larese",
    "46399182": "Joe Buckhalter",
    "46399183": "Adrian Smith",
    "46399184": "Howie Carl",
    "46399185": "Walt Bellamy",
    "46399186": "Dick Eichhorst",
    "46399187": "Donnie Butcher",
    "46399188": "Tom Meschery",
    "46399189": "Wayne Yates",
    "46399190": "Ray Scott",
    "46399191": "Cleo Hill",
    "46399192": "Paul Neumann",
    "46399193": "Ronald Martin",
    "46399194": "Cleveland Buckner",
    "46399195": "Bob Wiesenhahn",
    "46399196": "Al Butler",
    "46399197": "Dave Zeller",
    "46399198": "Gary Phillips",
    "46399199": "Robert Nordmann",
    "46399200": "Stacey Arceneaux",
    "46399201": "Johnny Egan",
    "46399202": "Sam Stith",
    "46399203": "Jack Turner",
    "46399698": "George Blaney",
    "46399699": "Bill Smith",
    "46399700": "Doug Kistler",
    "46399701": "Ron Horn",
    "46399702": "Jimmy Darrow",
    "46399703": "Chuck Osborne",
    "46399704": "Ed Burton",
    "46399705": "George H.",
    "46400200": "Dave DeBusschere",
    "46400201": "Dan Swartz",
    "46400202": "Enoch Olsen",
    "46400203": "John Barnhill",
    "46400204": "Charles Vaughn",
    "46400205": "John Havlicek",
    "46400206": "Len Chappell",
    "46400207": "Bill Bridges",
    "46400208": "Gene Tormohlen",
    "46400209": "John Rudometkin",
    "46400210": "Ben Warley",
    "46400211": "Bob Duffy",
    "46400212": "Zelmo Beaty",
    "46400213": "Kevin Loughery",
    "46400214": "Charlie Hardnett",
    "46400215": "Johnny Cox",
    "46400216": "Don Nelson",
    "46400217": "Terry Dischinger",
    "46400218": "Leroy Ellis",
    "46400219": "Wayne Hightower",
    "46400220": "Bill McGill",
    "46400221": "Gene Wiley",
    "46400222": "Chet Walker",
    "46400223": "Tom Stith",
    "46400224": "Jack Foley",
    "46400225": "Hubie White",
    "46400226": "Paul Hogue",
    "46400227": "Porter Meriwether",
    "46400228": "Mel Nowell",
    "46400229": "Dan Tieman",
    "46400724": "Howie Montgomery",
    "46400725": "Dave Fedor",
    "46400726": "Jeff Slade",
    "46400727": "Danny Doyle",
    "46400728": "Ralph Wells",
    "46400729": "Dave Gunther",
    "46400730": "Gary Hill",
    "46400731": "Rod Thorn",
    "46400732": "Don Kojis",
    "46400733": "Gus Johnson",
    "46400734": "Larry Siegfried",
    "46400735": "Nate Thurmond",
    "46400736": "Reggie Harding",
    "46400737": "Ken Rohloff",
    "46400738": "Gerry Ward",
    "46400739": "Eddie Miles",
    "46400740": "Jim King",
    "46400741": "Art Heyman",
    "46400742": "Tom Hoover",
    "46400743": "Jay Arnette",
    "46400744": "Jerry Lucas",
    "46400745": "Tom Thacker",
    "46400746": "Larry Comley",
    "46400747": "Mel Gibson",
    "46401242": "Jerry Greenspan",
    "46401243": "John Windsor",
    "46401244": "Mel Peterson",
    "46401245": "Jerry Harkness",
    "46401246": "Roger Strickland",
    "46401247": "Larry Jones",
    "46401248": "Emmette Bryant",
    "46401249": "Steve Courtin",
    "46401250": "Lucious Jackson",
    "46401251": "Barry Kramer",
    "46401252": "John Thompson",
    "46401253": "George Wilson",
    "46401254": "Happy Hairston",
    "46401255": "Ron Bonham",
    "46401256": "Gary Bradds",
    "46401257": "Mel Counts",
    "46401258": "Howard Komives",
    "46401259": "Willis Reed",
    "46401260": "Jim Barnes",
    "46401261": "Wali Jones",
    "46401262": "Mccoy McLemore",
    "46401263": "Bud Koper",
    "46401264": "Charles Nash",
    "46401265": "Walt Hazzard",
    "46401266": "Joe Caldwell",
    "46401761": "Jeff Mullins",
    "46401762": "Les Hunter",
    "46401763": "Jerry Grote",
    "46402258": "John Tresvant",
    "46402259": "Jim Washington",
    "46402260": "Dick Van",
    "46402261": "John Clemens",
    "46402262": "Dave Stallworth",
    "46402263": "Jerry Sloan",
    "46402264": "Billy Cunningham",
    "46402265": "Jon McGlocklin",
    "46402266": "Bill Buntin",
    "46402267": "Ron Reed",
    "46402268": "Fred Hetzel",
    "46402269": "Joe Strawder",
    "46402270": "Tom Van",
    "46402271": "Keith Erickson",
    "46402272": "John Fairchild",
    "46402273": "Gail Goodrich",
    "46402274": "Bob Warlick",
    "46403263": "Bob Weiss",
    "46403264": "Jesse Branson",
    "46403265": "Willie Somerset",
    "46403266": "Will Frazier",
    "46403267": "Thales McReynolds",
    "46403268": "Ron Watts",
    "46403269": "John Austin",
    "46403270": "Matt Guokas",
    "46403271": "Dorie Murrey",
    "46403272": "Clyde Lee",
    "46403273": "Wayne Molis",
    "46403274": "Henry Akin",
    "46403275": "Neil Johnson",
    "46403276": "Freddie Crawford",
    "46403277": "Jerry Chambers",
    "46403278": "Dave Bing",
    "46403279": "Jack Marin",
    "46403280": "Dave Schellhase",
    "46403281": "Archie Clark",
    "46403282": "Joe Ellis",
    "46403283": "Toby Kimball",
    "46403284": "Erwin Mueller",
    "46403285": "Jim Barnett",
    "46403286": "Cazzie Russell",
    "46403287": "Bill Melchionni",
    "46403288": "Jim Ware",
    "46403289": "Freddie Lewis",
    "46403290": "Tom Kron",
    "46403291": "Lou Hudson",
    "46403292": "Walt Wesley",
    "46403293": "Flynn Robinson",
    "46403294": "Dave Deutsch",
    "46403295": "Dick Snyder",
    "46403296": "Bob Hogsett",
    "46403297": "Hank Finkel",
    "46403298": "John Block",
    "46403299": "Stan McKenzie",
    "46403300": "Rick Weitzman",
    "46403301": "Johnny Jones",
    "46403302": "Roland West",
    "46403303": "Mal Graham",
    "46403304": "Ed Manning",
    "46403305": "Jim Fox",
    "46403306": "Jimmy Walker",
    "46403307": "Bill Bradley",
    "46403308": "Bob Love",
    "46403309": "Pat Riley",
    "46403310": "Clem Haskins",
    "46403311": "Arthur Williams",
    "46403312": "Bob Rule",
    "46403313": "Al Tucker",
    "46403314": "Craig Spitzer",
    "46403315": "Charles Acton",
    "46403316": "Dennis Hamilton",
    "46403317": "Cliff Anderson",
    "46403318": "Bobby Lewis",
    "46403319": "Bill Turner",
    "46403320": "Dave Lattin",
    "46403321": "Paul Long",
    "46403322": "Nate Bowman",
    "46403817": "Jim Davis",
    "46403818": "Lloyd Dove",
    "46403819": "George Patterson",
    "46403820": "George Lehmann",
    "46403821": "Bill Dinwiddie",
    "46403822": "Tyrone Britt",
    "46403823": "Gary Gray",
    "46403824": "John Wetzel",
    "46403825": "Plummer Lott",
    "46403826": "Tom Workman",
    "46403827": "Ron Filipek",
    "46403828": "Nick Jones",
    "46403829": "Jay Miller",
    "46404324": "Jim Reid",
    "46404325": "Ken Wilburn",
    "46404326": "Jim Burns",
    "46404327": "Jim Caldwell",
    "46404328": "Al Jackson",
    "46404329": "George Carter",
    "46404330": "Eldo Garrett",
    "46404331": "Mike Riordan",
    "46404332": "Harry Barnes",
    "46404333": "Rich Johnson",
    "46404334": "Stu Lantz",
    "46404335": "Joe Kennedy",
    "46404336": "Bob Quick",
    "46404337": "Rick Roberson",
    "46404338": "Wilmer Hosket",
    "46404339": "Mike Lynn",
    "46404340": "Shaler Halimon",
    "46404341": "Willie McCarter",
    "46404342": "Johnny Warren",
    "46404343": "Connie Hawkins",
    "46404344": "John Trapp",
    "46404345": "Zaid Abdul-Aziz",
    "46404346": "Rick Adelman",
    "46404347": "Fred Foster",
    "46404348": "Sam Williams",
    "46404349": "Pat Frink",
    "46404350": "Carlos Ogden",
    "46404351": "Gary Gregor",
    "46404352": "Bob Portman",
    "46404353": "Tom Boerwinkle",
    "46404354": "Bill Hewitt",
    "46404355": "Greg Smith",
    "46404356": "Art Harris",
    "46404357": "Dick Cunningham",
    "46404358": "Al Hairston",
    "46404359": "Bernie Williams",
    "46404360": "Otto Moore",
    "46404361": "Dale Schlueter",
    "46404362": "Dave Newmark",
    "46404363": "Loy Petersen",
    "46404364": "Bob Greacen",
    "46404365": "Steve Kuberski",
    "46404366": "Butch Beard",
    "46404367": "Lamar Green",
    "46404368": "Lee Winfield",
    "46404369": "Barry Orms",
    "46404370": "Lucius Allen",
    "46404371": "Don May",
    "46404372": "Ron Williams",
    "46404373": "Neal Walk",
    "46404374": "Jay Carty",
    "46404375": "Wally Anderzunas",
    "46404376": "Norm Van",
    "46404377": "Bob Kauffman",
    "46404378": "Brian Heaney",
    "46404379": "Fred Carter",
    "46404380": "Rich Niemann",
    "46404381": "Bob Allen",
    "46404382": "Skip Harlicka",
    "46404877": "Luke Rackley",
    "46404878": "Mike Davis",
    "46404879": "Herm Gilliam",
    "46404880": "Grady O'Malley",
    "46404881": "Craig Raymond",
    "46405376": "George Reynolds",
    "46405377": "Charlie Paulk",
    "46405378": "Doug Sims",
    "46405379": "John Arthurs",
    "46405380": "Dwight Waller",
    "46405381": "Ed Biedenbach",
    "46405382": "Rod Knowles",
    "46405383": "Cliff Williams",
    "46405384": "Dave Scholz",
    "46405385": "Johnny Baum",
    "46405386": "Bobby Washington",
    "46405387": "Geoff Petrie",
    "46405388": "Jim McMillian",
    "46405389": "Dean Meminger",
    "46405390": "Dave Sorenson",
    "46405391": "John Vallely",
    "46405392": "Ron Knight",
    "46405393": "Larry Mikan",
    "46405394": "Eddie Mast",
    "46405395": "Jeff Webb",
    "46405396": "Rich Rinaldi",
    "46405397": "Curtis Rowe",
    "46405398": "Joe Cooke",
    "46405399": "George Johnson",
    "46405400": "Gary Zeller",
    "46405401": "John Hummer",
    "46405402": "Marv Winkler",
    "46405403": "Isaiah Wilson",
    "46405404": "Pete Cross",
    "46405405": "Greg Howard",
    "46405406": "Tom Payne",
    "46405407": "Jake Ford",
    "46405408": "Dave Wohl",
    "46405409": "Nate Williams",
    "46405410": "Jim Marsh",
    "46405411": "Al Henry",
    "46405412": "Jimmy Collins",
    "46405413": "Harvey Marlatt",
    "46405414": "Mike Price",
    "46405415": "Clarence Glover",
    "46405416": "Stan Love",
    "46405417": "Terry Driscoll",
    "46405418": "Joe Thomas",
    "46405419": "Fred Taylor",
    "46405420": "Don Adams",
    "46405421": "Cornell Warner",
    "46405422": "Dick Gibbs",
    "46405423": "Fred Hilton",
    "46405424": "Rex Morgan",
    "46405425": "Charlie Yelverton",
    "46405426": "Levi Fontaine",
    "46405427": "George Trapp",
    "46405428": "Tom Black",
    "46405429": "Paul Ruffner",
    "46405430": "Gary Freeman",
    "46405431": "Ernie Killum",
    "46405432": "Garfield Smith",
    "46405433": "Jeff Halliburton",
    "46405434": "Greg Fillmore",
    "46405435": "Jim McDaniels",
    "46405436": "Thomas Barr",
    "46405437": "Curtis Perry",
    "46405438": "Cliff Meely",
    "46405439": "Willie Williams",
    "46405440": "Walt Gilmore",
    "46405441": "Bob Christian",
    "46405442": "Greg Hyder",
    "46405443": "Willie Norwood",
    "46405444": "Jackie Dinkins",
    "46405445": "Bob Arnzen",
    "46405446": "Gil McGregor",
    "46405447": "Steve Patterson",
    "46405448": "Barry Nelson",
    "46405449": "Kenny McIntosh",
    "46405450": "Chuck Lowery",
    "46405451": "Elmore Smith",
    "46405452": "Howard Porter",
    "46405453": "Dennis Layton",
    "46405454": "Herb White",
    "46405455": "Claude English",
    "46405456": "Mike Silliman",
    "46405457": "Barry Yates",
    "46405458": "Vic Bartolome",
    "46405459": "Odis Allison",
    "46405460": "Ralph Ogden",
    "46405955": "Milt Williams",
    "46405956": "Charlie Davis",
    "46405957": "Bill Zopf",
    "46405958": "Ken Durrett",
    "46405959": "Jackie Ridgle",
    "46406454": "Gary Suiter",
    "46406455": "Sid Catlett",
    "46406456": "Bob Riley",
    "46406457": "Jake Jones",
    "46406458": "Bill Smith",
    "46406459": "Alvin Holt",
    "46406460": "Bill Stricker",
    "46406955": "Dennis Stewart",
    "46406956": "Edward Davis",
    "46406957": "Paul McCracken",
    "46406958": "Fred Boyd",
    "46406959": "Phil Hankinson",
    "46406960": "Russell Lee",
    "46406961": "Bernie Fryer",
    "46406962": "Isaac Stallworth",
    "46406963": "Larry Cannon",
    "46406964": "Charlie Johnson",
    "46406965": "Vester Marshall",
    "46406966": "Gary Melchionni",
    "46406967": "Bill Chamberlain",
    "46406968": "Lloyd Neal",
    "46406969": "Slick Watts",
    "46406970": "Derrek Dickey",
    "46406971": "Larue Martin",
    "46406972": "Paul Stovall",
    "46406973": "Mark Sibley",
    "46406974": "Bob Verga",
    "46406975": "Scott English",
    "46406976": "John Brisker",
    "46406977": "Charles Dudley",
    "46406978": "Tom Ingelsby",
    "46406979": "Double D",
    "46406980": "Mike Macaluso",
    "46406981": "Joby Wright",
    "46406982": "Steve Bracey",
    "46406983": "Eric McWilliams",
    "46406984": "Rowland Garrett",
    "46406985": "Ron Riley",
    "46406986": "Ed Ratleff",
    "46406987": "Chuck Terry",
    "46406988": "Jim Price",
    "46406989": "Mel Davis",
    "46406990": "Frank Russell",
    "46406991": "Harthorne Wingo",
    "46406992": "Tom Kozelko",
    "46406993": "Steve Downing",
    "46406994": "Mike D'Antoni",
    "46406995": "Bob Nash",
    "46406996": "Travis Grant",
    "46406997": "Larry McNeill",
    "46406998": "Luke Witte",
    "46406999": "Emanuel Leaks",
    "46407000": "Justus Thigpen",
    "46407001": "Nate Hawthorne",
    "46407002": "John Tschogl",
    "46407003": "Louie Nelson",
    "46407004": "Ernie DiGregorio",
    "46407005": "E.C. Coleman",
    "46407006": "Ken Charles",
    "46407007": "Ben Kelso",
    "46407008": "Frank Schade",
    "46407009": "Mike Ratliff",
    "46407010": "Tommy Patterson",
    "46407011": "Rod Freeman",
    "46407012": "Bob Davis",
    "46407013": "Tom Riker",
    "46407508": "Sam Sibert",
    "46407509": "Jim Owens",
    "46408004": "Harold Fox",
    "46408005": "Ted Manakas",
    "46408006": "Joe Reaves",
    "46408007": "Jim Garvin",
    "46408008": "Mark Minor",
    "46408009": "Luther Green",
    "46408010": "Allie McGuire",
    "46408011": "Dennis Bell",
    "46408506": "Glenn McDonald",
    "46408507": "Gary Brokaw",
    "46408508": "Cliff Pondexter",
    "46408509": "Jim Ard",
    "46408510": "Aaron James",
    "46408511": "Wilbur Holland",
    "46408512": "Glenn Hansen",
    "46408513": "Phil Lumpkin",
    "46408514": "John Laskowski",
    "46408515": "Leonard Gray",
    "46408516": "Clyde Mayes",
    "46408517": "Talvin Skinner",
    "46408518": "Al Eberhard",
    "46408519": "Dean Tolson",
    "46408520": "Leon Benbow",
    "46408521": "Terry Thomas",
    "46408522": "Daniel Anderson",
    "46408523": "Dennis DuVal",
    "46408524": "Mike Sojourner",
    "46408525": "Bobby Wilson",
    "46408526": "Gene Short",
    "46408527": "Earl Williams",
    "46408528": "Henry Dickerson",
    "46408529": "Greg Jackson",
    "46408530": "Jim Creighton",
    "46408531": "Jimmy Jones",
    "46408532": "Jerome Anderson",
    "46408533": "Rod Derline",
    "46408534": "Bruce Seals",
    "46408535": "Fred Saunders",
    "46408536": "George Thompson",
    "46408537": "Steve Jones",
    "46408538": "Bob Bigelow",
    "46408539": "Connie Norman",
    "46408540": "Don Smith",
    "46408541": "Bill Ligon",
    "46408542": "Jesse Dark",
    "46408543": "Len Kosmalski",
    "46408544": "Robert Hawkins",
    "46408545": "Owen Wells",
    "46408546": "Tom Kropp",
    "46408547": "Wardell Jackson",
    "46408548": "Donnie Freeman",
    "46408549": "Ben Clyde",
    "46408550": "Frank Kendrick",
    "46408551": "Jerry Baskerville",
    "46408552": "Frank Oleynick",
    "46408553": "Lindsay Hairston",
    "46409048": "Bernie Harris",
    "46409049": "Al Carlson",
    "46409050": "Charles Kupec",
    "46409545": "Ed Searcy",
    "46409546": "Ken Boyd",
    "46409547": "Larry Fogle",
    "46409548": "Ken Mayfield",
    "46409549": "Perry Warbington",
    "46409550": "Greg Lee",
    "46409551": "Stan Washington",
    "46409552": "Roland Taylor",
    "46409553": "Ted, Hound",
    "46409554": "Phil Sellers",
    "46409555": "Ira Terrell",
    "46409556": "William Averitt",
    "46409557": "Chuck Williams",
    "46409558": "Robin Jones",
    "46409559": "Eddie Owens",
    "46409560": "Luther Burden",
    "46409561": "Monte Towe",
    "46409562": "Al Fleming",
    "46409563": "Byron Beck",
    "46409564": "Joe Pace",
    "46409565": "Phil Walker",
    "46409567": "Lou Dampier",
    "46409568": "Butch Feher",
    "46409569": "Willie Wise",
    "46409570": "Wil Jones",
    "46409571": "Jim Bostic",
    "46409572": "Andy Walker",
    "46409573": "Mo Howard",
    "46409574": "Bo Lamar",
    "46409575": "Claude Terry",
    "46409576": "Henry Ward",
    "46409577": "Johnny Neumann",
    "46409578": "Tate Armstrong",
    "46409579": "Wesley Cox",
    "46409580": "Phil Hicks",
    "46409581": "Tony Robertson",
    "46409582": "Norm Cook",
    "46409583": "Steve Sheppard",
    "46409584": "Marv Roberts",
    "46409585": "Steve Green",
    "46409586": "Eugene Kennedy",
    "46409587": "Jim Eakins",
    "46409588": "George Karl",
    "46409589": "Mike Flynn",
    "46409590": "Bayard Forrest",
    "46409591": "Wilson Washington",
    "46409592": "Greg Griffin",
    "46409593": "Mike Barr",
    "46409594": "Eric Marsh",
    "46409595": "Marshall Rogers",
    "46410090": "Tom Barker",
    "46410091": "Chuckie Williams",
    "46410092": "Randy Denton",
    "46410587": "Larry Moffett",
    "46411082": "Rich Jones",
    "46411083": "Rich Laurel",
    "46411084": "Keith Starr",
    "46411085": "Larry Johnson",
    "46411086": "Mark Crow",
    "46411581": "Mel Daniels",
    "46411582": "Scott Sims",
    "46411583": "Rudy Hackett",
    "46411584": "Glenn Mosley",
    "46411585": "Phil Bond",
    "46411586": "Wayman Britt",
    "46411587": "Darrell Elston",
    "46411588": "Cornelius Cash",
    "46411589": "Norton Barnhill",
    "46411590": "Allen Murphy",
    "46412085": "Wayne Radford",
    "46412086": "Tommy Green",
    "46412087": "John Rudd",
    "46412582": "Essie Hollis",
    "46412583": "Lars Hansen",
    "46413078": "Kim Anderson",
    "46413079": "Dennis Boyd",
    "46413080": "Ray Epps",
    "46413081": "Otis Howard",
    "46413082": "Greg Bunch",
    "46429879": "Ryan Robertson",
    "46429880": "Makhtar N'diaye",
    "46449661": "Jordan Sibert",
    "46658323": "Xavier Cooks",
    "47738533": "Jeenathan Williams",
    "47957121": "Justin Minaya",
    "48248287": "Jacob Gilyard",
    "48248491": "Chance Comanche",
      }
